import {
  Component,
  inject,
  signal,
  computed,
  input,
  output,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { GestionarContactosInformeDialogComponent } from 'src/app/presentation/shared/contactos/gestionar-contactos-informe-dialog.component';
import {
  gestionContactosInformeSiAplica,
  GestionContactosInformePendiente
} from 'src/app/presentation/shared/contactos/contactos-informe.utils';
import { avisarPostPersistencia } from 'src/app/common/aviso-post-persistencia';
import { FormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FieldsetModule } from 'primeng/fieldset';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { redondearCantidad } from 'src/app/common/cantidad.utils';
import { DecimalComaDirective } from '../../../../common/directives/decimal-coma.directive';
import { DecimalHintComponent } from '../../../shared/decimal-hint/decimal-hint.component';
import { HoraHintComponent } from '../../../shared/hora-hint/hora-hint.component';
import { InputTextarea } from 'primeng/inputtextarea';
import { DropdownModule } from 'primeng/dropdown';
import { DatePickerModule } from 'primeng/datepicker';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import {
  ProgramacionServicio,
  TipoCita,
  ProgramacionServicioRequest,
  UnidadNegocio
} from 'src/app/domain/model/agenda/agenda';
import { OrdenServicioDetalleProgramar } from 'src/app/domain/model/orden-servicio/orden-servicio';
import { AgendaRepository } from 'src/app/domain/service/agenda/agenda-repository';
import { BeneficiarioRepository } from 'src/app/domain/service/beneficiario/beneficiario-repository';
import {
  SCHEDULING_LABELS,
  SCHEDULING_TOOLTIPS,
  TIPOS_CITA_IDS,
  CAMPOS_POR_TIPO_CITA,
  CATALOGO_GRUPOS_ESTUDIO,
  CATALOGO_TIPOS_FORMACION,
  CATALOGO_TIPOS_INVESTIGACION,
  ESTADOS_EJECUTADOS
} from 'src/app/common/scheduling-constants';
import {
  ESTADO_CITA,
  MAX_OBSERVACIONES_CITA,
  LOCALE_NUMERICO,
  MAX_DECIMALES_CANTIDAD,
} from 'src/app/common/constants-ejb';
import {
  REGEX_ALPHANUMERIC_EXTENDED,
  REGEX_EMAIL,
  sanitizeText,
  sanitizeTextarea,
  sanitizeEmail,
  emailKeypress
} from 'src/app/common/input-utils';
import {
  ContactosTrabajoDialogComponent,
  ContactoCentroTrabajo,
  AccionPaginacionContactos
} from '../components/contactos-trabajo-dialog.component';
import {
  CancelarCitaDialogComponent,
  CancelarCitaResult,
  DatosPersona
} from '../components/cancelar-cita-dialog.component';
import {
  JustificacionTardiaDialogComponent,
  JustificacionTardiaResult
} from '../components/justificacion-tardia-dialog.component';
import {
  BusquedaClienteDialogComponent,
  ClienteSeleccionado
} from '../../../common/busquedas/busqueda-cliente-dialog.component';
import {
  BusquedaCentroTrabajoDialogComponent,
  CentroTrabajoSeleccionado
} from '../../../common/busquedas/busqueda-centro-trabajo-dialog.component';
import { environment } from 'src/environments/environment';
import {
  BusquedaTareaDialogComponent,
  TareaSeleccionada
} from '../../../common/busquedas/busqueda-tarea-dialog.component';
import { BusquedaUnidadNegocioDialogComponent } from '../../../common/busquedas/busqueda-unidad-negocio-dialog.component';
import { BusquedaProfesionalDialogComponent, BuscadorProfesionalOrigen } from '../../../common/busquedas/busqueda-profesional-dialog.component';
import { Profesional } from 'src/app/domain/model/profesional/profesional';
import { LoadingOverlayComponent } from '../../../shared/loading-overlay.component';
import { FormateadorDireccionComponent } from '../../../personas/formateador-direccion.component';
import {
  PanelTransporteComponent,
  TransporteData
} from '../components/panel-transporte.component';
import { NomenclaturaRepository } from 'src/app/domain/service/nomenclatura/nomenclatura-repository';
import { NomenclaturaDto } from 'src/app/domain/shared/models/nomenclatura';
import { Municipio } from 'src/app/domain/model/municipio/municipio';
import {
  CitaFacade,
  CitaFormModel,
  CitaMode as FacadeCitaMode
} from '../services/cita.facade';
import { superaLimiteDiasHabiles } from 'src/app/common/date-utils';
import { CumplimientoRepository } from 'src/app/domain/service/cumplimiento/cumplimiento-repository';
import { CatalogoRepository } from 'src/app/domain/service/catalogo/catalogo-repository';
import {
  ProgramacionPendiente,
  CumplimientoRequest,
  HistorialCumplimiento
} from 'src/app/domain/model/cumplimiento/cumplimiento';
import { FormularioCumplimientoComponent } from 'src/app/presentation/cumplimientos/components/formulario-cumplimiento/formulario-cumplimiento.component';
import { HistorialCumplimientosDialogComponent } from 'src/app/presentation/cumplimientos/components/historial-cumplimientos-dialog/historial-cumplimientos-dialog.component';
import { MunicipioPrecargado } from 'src/app/presentation/cumplimientos/components/seccion-transporte/seccion-transporte.component';
import { abrirAlertaTemprana } from 'src/app/common/alerta-temprana.utils';
import {
  esTipoCitaCampo,
  esTipoCitaInforme
} from 'src/app/common/tipo-cita.utils';
import { ContadorCaracteresDirective } from 'src/app/presentation/shared/contador-caracteres/contador-caracteres.directive';

/**
 * Constantes de tipos de cita - Migrado desde ConstantsEJB.TpscTiposDeCitas
 * Usando las constantes compartidas del módulo common
 */
export const TIPOS_CITA = TIPOS_CITA_IDS;

/** Legacy (CrearCitaAdministrativaViewImpl.reset): tipo de cita con dsuso_cita = LINEAAT. */
const USO_CITA_LINEA_AT = 'LINEAAT';

/**
 * Modos de operación - Migrado desde Constants.TOKEN_*
 */
export type CitaMode = 'view' | 'edit' | 'create';

/**
 * DiálogoCitaComponent
 *
 * Componente único para crear, editar y ver citas.
 * Implementa la lógica del legacy ServiceAppointmentInterfaceImpl.java
 *
 * Reglas de visibilidad:
 * - Dirección física: solo visible para tipo CAMPO (17, 42)
 * - Sincronización Outlook: solo visible para tipo CAMPO (17, 42)
 * - Enlace Teams: solo visible para tipo CAMPO y cuando snenlaceTeams='S'
 * - Accordion Cumplimiento: visible solo si cita tiene orden de servicio
 *
 * Reglas de habilitación:
 * - Modo 'view': todos los campos readonly
 * - Modo 'edit': campos editables según estado de la cita
 * - Modo 'create': todos los campos editables (excepto estado)
 *
 * @author Emerson Rodriguez - Ingeneo
 */
@Component({
  selector: 'app-cita-dialog',
  standalone: true,
  imports: [
    ContadorCaracteresDirective,
    CommonModule,
    FormsModule,
    DialogModule,
    GestionarContactosInformeDialogComponent,
    FieldsetModule,
    ButtonModule,
    InputTextModule,
    InputNumberModule,
    DecimalComaDirective,
    DecimalHintComponent,
    HoraHintComponent,
    InputTextarea,
    DropdownModule,
    DatePickerModule,
    RadioButtonModule,
    TooltipModule,
    TagModule,
    ConfirmDialogModule,
    ContactosTrabajoDialogComponent,
    CancelarCitaDialogComponent,
    JustificacionTardiaDialogComponent,
    BusquedaClienteDialogComponent,
    BusquedaCentroTrabajoDialogComponent,
    BusquedaTareaDialogComponent,
    BusquedaUnidadNegocioDialogComponent,
    BusquedaProfesionalDialogComponent,
    LoadingOverlayComponent,
    FormateadorDireccionComponent,
    PanelTransporteComponent,
    FormularioCumplimientoComponent,
    HistorialCumplimientosDialogComponent
  ],
  providers: [ConfirmationService, CitaFacade],
  styles: [
    `
      :host
        ::ng-deep
        .p-fieldset-toggleable:not(.p-fieldset-expanded)
        > .p-fieldset-content-container {
        height: 0 !important;
        overflow: hidden;
      }
    `
  ],
  template: `
    <p-dialog
      [(visible)]="visible"
      [header]="dialogTitle()"
      [modal]="true"
      [style]="{
        width: '92vw',
        maxWidth: mode() === 'create' ? '44rem' : '62rem'
      }"
      [contentStyle]="{
        'max-height': '80vh',
        'overflow-y': 'auto',
        'overflow-x': 'hidden'
      }"
      [breakpoints]="{
        '1280px': '92vw',
        '1024px': '94vw',
        '768px': '96vw',
        '640px': '98vw'
      }"
      [closable]="true"
      (onHide)="onDialogHide()"
    >
      <!-- ======================================== -->
      <!-- MODO CREATE: Vista simple como el legacy -->
      <!-- ======================================== -->
      @if (mode() === 'create') {
        <!-- Acordeón: Detalles de la tarea (solo visible si viene de orden de servicio) -->
        @if (esOrdenServicio()) {
          <p-fieldset
            legend="Detalles de la tarea"
            [toggleable]="true"
            [collapsed]="true"
            styleClass="mb-4"
          >
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <!-- Aseguradora (línea completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Aseguradora</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.aseguradora ||
                    'SEGUROS DE RIESGOS PROFESIONALES SURAMERICANA S.A.'
                }}</span>
              </div>

              <!-- Cliente (línea completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Cliente</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.nombreBeneficiario || '-'
                }}</span>
              </div>

              <!-- Orientación de Servicio -->
              <div>
                <label class="text-xs text-gray-500 block"
                  >Orientación de Servicio</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.orientacionServicio ||
                    ordenServicioDetalle()?.codigoOrden ||
                    '-'
                }}</span>
              </div>

              <!-- Unidad Administrativa -->
              <div>
                <label class="text-xs text-gray-500 block"
                  >Unidad Administrativa</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.unidadEstrategica || '-'
                }}</span>
              </div>

              <!-- Clasificación -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block">Clasificación</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.clasificacion || '-'
                }}</span>
              </div>

              <!-- Producto (línea completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Producto</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.producto || '-'
                }}</span>
              </div>

              <!-- Tarea (línea completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Tarea</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.tareaCliente || '-'
                }}</span>
              </div>

              <!-- Servicio CGR (línea completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Servicio CGR</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.servicioCgr || '-'
                }}</span>
              </div>

              <!-- Requiere informe + Fechas en misma fila -->
              <div>
                <label class="text-xs text-gray-500 block"
                  >Requiere informe</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.requiereInforme || 'NO'
                }}</span>
              </div>
              <div>
                <label class="text-xs text-gray-500 block"
                  >Fecha inicial de entrega</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.fechaEntregaInicial || '-'
                }}</span>
              </div>
              <div>
                <label class="text-xs text-gray-500 block"
                  >Fecha final de entrega</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.fechaEntregaFinal || '-'
                }}</span>
              </div>
              <div></div>

              <!-- Cantidades en misma fila -->
              <div>
                <label class="text-xs text-gray-500 block"
                  >Cantidad pedida</label
                >
                <span class="font-medium"
                  >{{ ordenServicioDetalle()?.cantidadPedida ?? 0 }}
                  {{ ordenServicioDetalle()?.unidadMedida || '' }}</span
                >
              </div>
              <div>
                <label class="text-xs text-gray-500 block"
                  >Cantidad programada</label
                >
                <span class="font-medium"
                  >{{ ordenServicioDetalle()?.cantidadProgramada ?? 0 }}
                  {{ ordenServicioDetalle()?.unidadMedida || '' }}</span
                >
              </div>
              <div>
                <label class="text-xs text-gray-500 block"
                  >Saldo por programar</label
                >
                <span
                  class="font-bold"
                  [class.text-red-600]="
                    (ordenServicioDetalle()?.saldoPorProgramar || 0) > 0
                  "
                >
                  {{ ordenServicioDetalle()?.saldoPorProgramar ?? 0 }}
                  {{ ordenServicioDetalle()?.unidadMedida || '' }}
                </span>
              </div>
              <div>
                <label class="text-xs text-gray-500 block"
                  >Saldo por ejecutar</label
                >
                <span
                  class="font-medium"
                  [class.text-orange-600]="
                    (ordenServicioDetalle()?.saldoPorEjecutar || 0) > 0
                  "
                >
                  {{ ordenServicioDetalle()?.saldoPorEjecutar ?? 0 }}
                  {{ ordenServicioDetalle()?.unidadMedida || '' }}
                </span>
              </div>

              <!-- Estado de la programación -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block"
                  >Estado de la programación</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.estado || '-'
                }}</span>
              </div>

              <!-- Profesional -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Profesional</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.profesional || '-'
                }}</span>
              </div>

              <!-- Consultor sugerido -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block"
                  >Consultor sugerido</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.asesorSugerido || '-'
                }}</span>
              </div>

              <!-- Nombre Contacto -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block"
                  >Nombre Contacto</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.nombreContacto || '-'
                }}</span>
              </div>

              <!-- Teléfono del Contacto -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block"
                  >Teléfono del Contacto</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.telefonoContacto || '-'
                }}</span>
              </div>

              <!-- Centro de trabajo (fila completa) -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block"
                  >Centro de trabajo</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.centroTrabajo || '-'
                }}</span>
              </div>

              <!-- Municipio de entrega -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block"
                  >Municipio de entrega</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.municipioDestino || '-'
                }}</span>
              </div>

              <!-- Dirección de entrega -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block"
                  >Dirección de entrega</label
                >
                <span class="font-medium">{{
                  ordenServicioDetalle()?.direccionEntrega || '-'
                }}</span>
              </div>

              <!-- Localidad -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block">Localidad</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.localidad || '-'
                }}</span>
              </div>

              <!-- Barrio -->
              <div class="lg:col-span-2">
                <label class="text-xs text-gray-500 block">Barrio</label>
                <span class="font-medium">{{
                  ordenServicioDetalle()?.barrio || '-'
                }}</span>
              </div>

              <!-- Observación -->
              <div class="col-span-full">
                <label class="text-xs text-gray-500 block">Observación</label>
                <p class="text-sm mt-1 whitespace-pre-wrap">
                  {{ ordenServicioDetalle()?.notas || '-' }}
                </p>
              </div>
            </div>
          </p-fieldset>
        }

        <!-- Sección: Datos de la cita -->
        <div class="mb-2 font-medium text-gray-700">Datos de la cita</div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- 1. Tipo programación -->
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">
              Tipo programación <span class="text-red-500">*</span>
            </label>
            <p-dropdown
              [(ngModel)]="form.nmconsecutivoTipoCita"
              [options]="tiposCitaFiltrados()"
              optionLabel="dstipo"
              optionValue="nmconsecutivo"
              placeholder="--Seleccione una opción--"
              [filter]="true"
              filterBy="dstipo"
              [style]="{ width: '100%' }"
              appendTo="body"
              (ngModelChange)="onTipoCitaChange()"
            >
            </p-dropdown>
          </div>

          <!-- Estado de la cita: NO se muestra en modo CREATE (legacy no lo muestra) -->
          <!-- El estado se asigna automáticamente como "CITA PROGRAMADA" al grabar -->

          <!-- 2. Enlace de Teams (fila completa): oculto para INFORME (resolverVisibilidadContactos) -->
          @if (visibility().mostrarEnlaceTeams) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Enlace de Teams <span class="text-red-500">*</span>
              </label>
              <div class="flex flex-wrap gap-4 mt-1">
                <div class="flex items-center">
                  <p-radioButton
                    name="snEnlaceTeams"
                    value="S"
                    [(ngModel)]="form.snEnlaceTeams"
                    (ngModelChange)="onEnlaceTeamsChange($event)"
                    inputId="teamsCreateSi"
                  >
                  </p-radioButton>
                  <label for="teamsCreateSi" class="ml-2">Sí</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton
                    name="snEnlaceTeams"
                    value="N"
                    [(ngModel)]="form.snEnlaceTeams"
                    (ngModelChange)="onEnlaceTeamsChange($event)"
                    inputId="teamsCreateNo"
                  >
                  </p-radioButton>
                  <label for="teamsCreateNo" class="ml-2">No</label>
                </div>
              </div>
            </div>
          }

          <!-- ============================================================ -->
          <!-- CAMPOS DINÁMICOS POR TIPO DE CITA (legacy: onListBoxTypeChange) -->
          <!-- ORDEN LEGACY XML: Beneficiario -> PPR -> Centro Trabajo -> Tarea -> Contacto -> Fecha/Hora -> Duracion -> Direccion -> Periodicidad -> Observacion -> Virtual -> Grupo/Formacion -->
          <!-- ============================================================ -->

          <!-- 3. Beneficiario/Cliente - para tipos: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO, PROGRAMACION_EN_CLIENTE, etc. -->
          <!-- Legacy: BuscarBeneficiarioViewImpl - muestra Contrato, Identificación, Nombre en campos separados -->
          @if (visibility().mostrarBeneficiario) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Cliente <span class="text-red-500">*</span>
              </label>
              <div
                class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
              >
                <!-- Contrato -->
                <input
                  pInputText
                  [(ngModel)]="form.dscontratoBeneficiario"
                  placeholder="Contrato"
                  readonly
                  class="w-full sm:w-28 cursor-pointer"
                  (click)="abrirBusquedaCliente()"
                />
                <!-- Identificación -->
                <input
                  pInputText
                  [(ngModel)]="form.dsidentificacionBeneficiario"
                  placeholder="Identificación"
                  readonly
                  class="w-full sm:w-28 cursor-pointer"
                  (click)="abrirBusquedaCliente()"
                />
                <!-- Nombre Comercial -->
                <input
                  pInputText
                  [(ngModel)]="form.dsnombreBeneficiario"
                  placeholder="Nombre"
                  readonly
                  class="w-full sm:flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaCliente()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar cliente"
                  (click)="abrirBusquedaCliente()"
                ></button>
              </div>
            </div>
          }

          <!-- 4. PPR (Profesional) - para tipo: SEGUIMIENTO_INTEGRAL_CLIENTE (25) -->
          <!-- Legacy: tblSelectPpr con stbNamePpr (nombre) + stbMailPpr (correo) + siBuscarPpr (lupa) + siAgregaPpr (+) -->
          @if (visibility().mostrarPPR) {
            <!-- Fila 1: Profesional PPR -->
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Nombre del profesional <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                [(ngModel)]="form.dsnombrePPR"
                placeholder="Buscar profesional"
                readonly
                class="w-full"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1"
                >Correo</label
              >
              <div class="flex gap-2 min-w-0">
                <input
                  pInputText
                  [(ngModel)]="form.dscorreoPPR"
                  readonly
                  class="flex-1 min-w-0"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar profesional"
                  (click)="abrirBusquedaPPR()"
                ></button>
                <button
                  pButton
                  icon="pi pi-plus"
                  class="p-button-text min-w-[44px] min-h-[44px]"
                  pTooltip="Adicionar contactos"
                  (click)="agregarContactoPPR()"
                ></button>
              </div>
            </div>

            <!-- Fila 2: Contacto adicional (legacy: trMailAdd) - inicialmente oculta -->
            @if (mostrarContactoAdicionalPPR) {
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1"
                  >Nombre Contacto</label
                >
                <input
                  pInputText
                  [(ngModel)]="form.dsnombreContactoPPR"
                  (input)="form.dsnombreContactoPPR = sanitizeText(form.dsnombreContactoPPR)"
                  class="w-full"
                  maxlength="100"
                  placeholder="Nombre del contacto"
                />
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1"
                  >Correo</label
                >
                <div class="flex gap-2 min-w-0">
                  <input
                    pInputText
                    [(ngModel)]="form.dscorreoContactoPPR"
                    (keypress)="emailKeypress($event)"
                    (input)="form.dscorreoContactoPPR = sanitizeEmail(form.dscorreoContactoPPR)"
                    class="flex-1 min-w-0"
                    maxlength="100"
                    placeholder="Correo del contacto"
                  />
                  <button
                    pButton
                    icon="pi pi-times"
                    class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                    pTooltip="Eliminar contacto"
                    (click)="eliminarContactoPPR()"
                  ></button>
                </div>
              </div>
            }
          }

          <!-- 5. Centro de Trabajo - para tipos: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO -->
          @if (visibility().mostrarCentroTrabajo) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Centro de trabajo
              </label>
              <div
                class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
              >
                <input
                  pInputText
                  [(ngModel)]="form.dsnombreCentroTrabajo"
                  placeholder="Centro de trabajo"
                  readonly
                  class="w-full sm:flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaCentroTrabajo()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar centro de trabajo"
                  (click)="abrirBusquedaCentroTrabajo()"
                ></button>
              </div>
            </div>
          }

          <!-- 6. Tarea - para tipos: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO, CITA_TENTATIVA, TUTORIA -->
          @if (visibility().mostrarTarea) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Nombre Tarea <span class="text-red-500">*</span>
              </label>
              <div
                class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
              >
                <input
                  pInputText
                  [(ngModel)]="form.dsnombreTarea"
                  placeholder="Seleccione una tarea"
                  readonly
                  class="w-full sm:flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaTarea()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar tarea"
                  (click)="abrirBusquedaTarea()"
                ></button>
              </div>
            </div>
          }

          <!-- 7. Campos de contacto: CAMPO y Línea AT siempre; INFORME nunca; demás solo con Teams = Sí -->
          @if (visibility().mostrarContactos) {
            <!-- Contacto -->
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Contacto <span class="text-red-500">*</span>
              </label>
              <div
                class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
              >
                <input
                  pInputText
                  [(ngModel)]="form.dsnombreContacto"
                  placeholder="Haga click para abrir la lista de Contactos del cliente"
                  readonly
                  class="w-full sm:flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaContacto()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar contacto"
                  (click)="abrirBusquedaContacto()"
                ></button>
              </div>
            </div>

            <!-- Teléfono fijo (readonly - se carga del contacto seleccionado) -->
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1"
                >Teléfono fijo</label
              >
              <input
                pInputText
                [(ngModel)]="form.dstelefonoContacto"
                readonly
                class="w-full"
              />
            </div>

            <!-- Teléfono celular (readonly - se carga del contacto seleccionado) -->
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1"
                >Teléfono celular</label
              >
              <input
                pInputText
                [(ngModel)]="form.dscelularContacto"
                readonly
                class="w-full"
              />
            </div>

            <!-- Email (readonly - se carga del contacto seleccionado) -->
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1"
                >Email</label
              >
              <input
                pInputText
                [(ngModel)]="form.dsemailContacto"
                type="email"
                readonly
                class="w-full"
              />
            </div>
          }

          <!-- ============================================================ -->
          <!-- FIN CAMPOS DINÁMICOS ANTES DE FECHA/HORA -->
          <!-- ============================================================ -->

          <!-- 7. Fecha cita (aaaa/mm/dd) -->
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">
              Fecha cita (aaaa/mm/dd) <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              [(ngModel)]="form.fechaCita"
              dateFormat="yy/mm/dd"
              [showIcon]="true"
              [style]="{ width: '100%' }"
              appendTo="body"
            >
            </p-datepicker>
          </div>

          <!-- 7b. Hora de inicio (HH:MM) -->
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">
              Hora de inicio (HH:MM) <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              [(ngModel)]="form.horaInicio"
              [timeOnly]="true"
              hourFormat="24"
              [showIcon]="true"
              [stepMinute]="1"
              [style]="{ width: '100%' }"
              appendTo="body"
            >
            </p-datepicker>
          <app-hora-hint [id]="'cita-hora-inicio-ayuda-1'" />
          </div>

          <!-- 7c. Duración -->
          <div>
            <label class="block text-sm font-medium text-gray-600 mb-1">
              Duración <span class="text-red-500">*</span>
            </label>
            <p-datepicker
              [(ngModel)]="form.duracion"
              [timeOnly]="true"
              hourFormat="24"
              [showIcon]="true"
              [stepMinute]="1"
              [defaultDate]="defaultDuracion"
              [disabled]="!habilitacion().habilitarDuracion"
              [style]="{ width: '100%' }"
              (ngModelChange)="onDuracionChange($event)"
              appendTo="body"
            >
            </p-datepicker>
          </div>

          <!-- 7c.1. Cantidad programada: SOLO visible para citas de SERVICIO (CAMPO, INFORME) -->
          @if (visibility().mostrarCantidadProgramada) {
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Cantidad programada <span class="text-red-500">*</span>
              </label>
              @if (habilitacion().habilitarCantidad) {
                <div class="p-inputgroup">
                  <p-inputNumber
                    appDecimalComa
                    [(ngModel)]="form.nmcantidadProgramada"
                    [locale]="localeNumerico"
                    [min]="0.01"
                    [minFractionDigits]="0"
                    [maxFractionDigits]="maxDecimalesCantidad"
                    [useGrouping]="false"
                    ariaDescribedBy="ayuda-cantidad-programada"
                    placeholder="0,00"
                    inputStyleClass="w-full"
                  />
                  <span class="p-inputgroup-addon">{{
                    ordenServicioDetalle()?.unidadMedida || 'HORAS'
                  }}</span>
                </div>
                <app-decimal-hint
                  id="ayuda-cantidad-programada"
                  ejemplo="1,5"
                />
              } @else {
                <input
                  pInputText
                  [value]="
                    formatDecimal(form.nmcantidadProgramada) +
                    ' ' +
                    (ordenServicioDetalle()?.unidadMedida || 'HORAS')
                  "
                  readonly
                  class="w-full"
                />
              }
            </div>
          }

          <!-- 7d. Dirección - para tipos: CAMPO (17), CITA_TENTATIVA (20) -->
          <!-- Legacy: trDireccion visible para CAMPO y CITA_TENTATIVA -->
          @if (visibility().mostrarDireccion) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Dirección
              </label>
              <div class="flex gap-2 min-w-0">
                <input
                  pInputText
                  [(ngModel)]="form.dsdireccion"
                  placeholder="Seleccione una dirección"
                  readonly
                  class="flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaDireccion()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar dirección"
                  (click)="abrirBusquedaDireccion()"
                ></button>
              </div>
            </div>
          }

          <!-- 8. Periodicidad -->
          @if (!visibility().ocultarPeriodicidad) {
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1"
                >Periodicidad</label
              >
              <p-dropdown
                [(ngModel)]="form.tipoperiodicidad"
                [options]="periodicidades"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                placeholder="--Seleccione una opción--"
                [style]="{ width: '100%' }"
                appendTo="body"
                (ngModelChange)="onPeriodicidadChange()"
              >
              </p-dropdown>
            </div>

            <!-- Campos de periodicidad: solo visibles cuando hay periodicidad seleccionada -->
            <!-- Legacy: setVisiblePeriodicity(getSlbPeriodicity().getSelectedIndex() > 0, false) -->
            @if (form.tipoperiodicidad) {
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1"
                  >Cantidad total programada</label
                >
                <input pInputText [value]="'-'" readonly class="w-full" />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Repeticiones <span class="text-red-500">*</span>
                </label>
                <input
                  pInputText
                  [(ngModel)]="form.nmrepeticiones"
                  type="number"
                  min="1"
                  class="w-full"
                  (ngModelChange)="onRepeticionesChange()"
                />
              </div>

              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Fecha fin periodicidad
                </label>
                <input
                  pInputText
                  [value]="
                    form.fechaFinPeriodicidad
                      ? (form.fechaFinPeriodicidad | date: 'yyyy/MM/dd')
                      : '-'
                  "
                  readonly
                  class="w-full"
                />
              </div>
            }
          }

          <!-- 9. Observación -->
          <div class="md:col-span-2">
            <label class="block text-sm font-medium text-gray-600 mb-1">
              Observación
              @if (visibility().observacionObligatoria) {
                <span class="text-red-500">*</span>
              }
            </label>
            <textarea
              pInputTextarea
              [(ngModel)]="form.dsobservaciones"
              (change)="form.dsobservaciones = sanitizeTextarea(form.dsobservaciones)"
              [appContadorCaracteres]="maxObservaciones"
              rows="3"
              class="w-full"
            >
            </textarea>
          </div>

          <!-- ============================================================ -->
          <!-- CAMPOS DINAMICOS DESPUES DE OBSERVACION (legacy: final del form) -->
          <!-- ============================================================ -->

          <!-- 10. Atención Virtual S/N - para tipos: TUTORIA_PEC_PAI, TUTORIA_CAMPO -->
          @if (visibility().mostrarVirtual) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Atención virtual <span class="text-red-500">*</span>
              </label>
              <div class="flex flex-wrap gap-4 mt-1">
                <div class="flex items-center">
                  <p-radioButton
                    name="snvirtual"
                    value="S"
                    [(ngModel)]="form.snvirtual"
                    inputId="virtualSi"
                    (ngModelChange)="onVirtualChange($event)"
                  ></p-radioButton>
                  <label for="virtualSi" class="ml-2">Sí</label>
                </div>
                <div class="flex items-center">
                  <p-radioButton
                    name="snvirtual"
                    value="N"
                    [(ngModel)]="form.snvirtual"
                    inputId="virtualNo"
                    (ngModelChange)="onVirtualChange($event)"
                  ></p-radioButton>
                  <label for="virtualNo" class="ml-2">No</label>
                </div>
              </div>
            </div>
          }

          <!-- 10.1 Panel Transporte - visible cuando Virtual=NO para tipos 40,41 -->
          <!-- Legacy: mostrarOcultarTransporte() en CrearCitaAdministrativaViewImpl.java -->
          @if (visibility().mostrarTransporte) {
            <app-panel-transporte
              [data]="transporteData"
              (dataChange)="onTransporteDataChange($event)"
            />
          }

          <!-- 11. Grupo de Estudio - para tipo: GRUPO_ESTUDIO (12) -->
          @if (visibility().mostrarGrupoEstudio) {
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Número del grupo de estudio <span class="text-red-500">*</span>
              </label>
              <p-dropdown
                [(ngModel)]="form.nmgrupoEstudio"
                [options]="gruposEstudio"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione"
                [filter]="true"
                filterBy="label"
                [style]="{ width: '100%' }"
                appendTo="body"
              >
              </p-dropdown>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Línea de estudio <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                [(ngModel)]="form.dslineaEstudio"
                (input)="form.dslineaEstudio = sanitizeText(form.dslineaEstudio)"
                class="w-full"
              />
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Tema de estudio <span class="text-red-500">*</span>
              </label>
              <input
                pInputText
                [(ngModel)]="form.dstema"
                (input)="form.dstema = sanitizeText(form.dstema)"
                class="w-full"
              />
            </div>
          }

          <!-- 12. Formación Técnica - para tipo: FORMACION_TECNICA (15) -->
          @if (visibility().mostrarFormacionTecnica) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Tipo de formación <span class="text-red-500">*</span>
              </label>
              <p-dropdown
                [(ngModel)]="form.cdtipoFormacion"
                [options]="tiposFormacion"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione"
                [filter]="true"
                filterBy="label"
                [style]="{ width: '100%' }"
                scrollHeight="200px"
                panelStyleClass="dropdown-open-up"
                appendTo="body"
              >
              </p-dropdown>
            </div>
          }

          <!-- 13. Investigación Aplicada - para tipo: INVESTIGACION_APLICADA (52) -->
          @if (visibility().mostrarInvestigacion) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Tipo de investigación <span class="text-red-500">*</span>
              </label>
              <p-dropdown
                [(ngModel)]="form.cdtipoInvestigacion"
                [options]="tiposInvestigacion"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccione"
                [filter]="true"
                filterBy="label"
                [style]="{ width: '100%' }"
                scrollHeight="200px"
                panelStyleClass="dropdown-open-up"
                appendTo="body"
              >
              </p-dropdown>
            </div>
          }

          <!-- 14. Unidad de Negocio - para tipo: CONTENIDOS_TECNICOS (54) -->
          <!-- Legacy: Abre buscador con Código/Nombre de TPSC_UNIDADES_NEGOCIO -->
          <!-- Formato display: "3 - RIESGOS LABORALES ARL" (código - nombre) -->
          @if (visibility().mostrarUnidadNegocio) {
            <div class="md:col-span-2">
              <label class="block text-sm font-medium text-gray-600 mb-1">
                Unidad de negocio <span class="text-red-500">*</span>
              </label>
              <div class="flex gap-2 min-w-0">
                <input
                  pInputText
                  [(ngModel)]="form.dsunidadNegocio"
                  placeholder="Seleccione una unidad de negocio"
                  readonly
                  class="flex-1 min-w-0 cursor-pointer"
                  (click)="abrirBusquedaUnidadNegocio()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar unidad de negocio"
                  (click)="abrirBusquedaUnidadNegocio()"
                ></button>
              </div>
            </div>
          }
        </div>
      }

      <!-- ======================================== -->
      <!-- MODO EDIT/VIEW: Vista completa con accordions -->
      <!-- Legacy: Tanto EDIT_RECORD como READ_ONLY muestran 3 accordions -->
      <!-- ======================================== -->
      @if ((mode() === 'edit' || mode() === 'view') && cita()) {
        <!-- Estado de la cita a la derecha -->
        @if (visibility().mostrarEstado) {
          <div class="flex justify-end mb-4 pb-3 border-b">
            <p-tag
              [value]="cita()?.dsestado || cita()?.cdestado || 'Sin estado'"
              [style]="{ 'background-color': estadoColor() }"
            >
            </p-tag>
          </div>
        }

        <div class="flex flex-col gap-4">
          <!-- Fieldset 1: Detalle de la tarea (SOLO visible con orden de servicio) -->
          @if (visibility().mostrarAccordionDetalleOrden) {
            <p-fieldset
              legend="Detalle de la tarea"
              [toggleable]="true"
              [collapsed]="true"
            >
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
                <!-- Aseguradora -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Aseguradora</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.nombreAseguradora || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Cliente -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Cliente</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.nombreBeneficiario || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Orientación de servicio -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Orientación de servicio</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.orientacionServicio || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Unidad Administrativa -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Unidad Administrativa</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsunidadAdministrativa || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Producto -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Producto</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsproducto || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Clasificación -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Clasificación</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsclasificacion || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Tarea -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Tarea</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dstarea || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Servicio CGR -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Servicio CGR</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsservicioCGR || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Requiere informe -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Requiere informe</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.snrequiereInforme || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Fechas de entrega -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Fecha inicial de entrega</label
                  >
                  <input
                    pInputText
                    [value]="formatFecha(cita()?.feentregaInicial)"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Fecha final de entrega</label
                  >
                  <input
                    pInputText
                    [value]="formatFecha(cita()?.feentregaFinal)"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Cantidades -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Cantidad pedida</label
                  >
                  <input
                    pInputText
                    [value]="formatDecimal(cita()?.nmcantidadPedida)"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Cantidad programada</label
                  >
                  <input
                    pInputText
                    [value]="formatDecimal(cita()?.cantProgramadaOs)"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Saldos -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Saldo por programar</label
                  >
                  <input
                    pInputText
                    [value]="formatDecimal(cita()?.saldoProgramar)"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Saldo por ejecutar</label
                  >
                  <input
                    pInputText
                    [value]="formatDecimal(cita()?.saldoEjecutar)"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Estado de la programación -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Estado de la programación</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsestadoProgramacionOs || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Profesional -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Profesional</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.nombreProfesional || cita()?.dsprofesional || '-'
                    "
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Consultor sugerido -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Consultor sugerido</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.nombreConsultorSugerido ||
                      cita()?.dsconsultorSugerido ||
                      '-'
                    "
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Contacto OS -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Nombre Contacto</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsnombreContactoOs || '-'"
                    readonly
                    class="w-full"
                  />
                </div>
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Teléfono del Contacto</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dstelefonoContactoOs || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Dirección de entrega -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Dirección de entrega</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.dsdireccionEntrega || cita()?.dsdireccion || '-'
                    "
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Municipio de entrega -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Municipio de entrega</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsmunicipioEntrega || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Centro de trabajo -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Centro de trabajo</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dscentroTrabajo || '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Localidad y Barrio -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Localidad</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.dslocalidadPpal || cita()?.dslocalidad || ''
                    "
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Barrio</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.dsbarrioPpal || cita()?.dsbarrio || ''"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Observación -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Observación</label
                  >
                  <textarea
                    pInputTextarea
                    [value]="cita()?.dsobservacionesOrden || ''"
                    readonly
                    rows="2"
                    class="w-full"
                  ></textarea>
                </div>
              </div>
            </p-fieldset>
          }

          <!-- Fieldset 2: Detalle de cumplimiento -->
          @if (visibility().mostrarAccordionCumplimiento) {
            <p-fieldset
              legend="Detalle de cumplimiento"
              [toggleable]="true"
              [collapsed]="true"
            >
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
                <!-- Pago transporte empleado -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Pago transporte empleado SN</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.snpagoTransporteEmpleado ||
                      (cita()?.requiereTransporte ? 'S' : 'N')
                    "
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Valor transporte empleado</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.ptvalorTransporte ?? '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Transporte adicional -->
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Transporte adicional SN</label
                  >
                  <input
                    pInputText
                    [value]="
                      cita()?.snTransporteAdicional ||
                      (cita()?.requiereTransporteAdicional ? 'S' : 'N')
                    "
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Valor transporte adicional</label
                  >
                  <input
                    pInputText
                    [value]="cita()?.ptvalorTransporteAdicional ?? '-'"
                    readonly
                    class="w-full"
                  />
                </div>

                <!-- Observaciones transporte -->
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Observaciones del transporte adicional</label
                  >
                  <textarea
                    pInputTextarea
                    [value]="cita()?.dsobservacionesTransporte || '-'"
                    readonly
                    rows="2"
                    class="w-full"
                  ></textarea>
                </div>
              </div>
            </p-fieldset>
          }

          <!-- Fieldset 3: Datos de la cita -->
          <p-fieldset legend="Datos de la cita" [toggleable]="true">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
              <!-- Tipo programación (legacy: slbAppointmentType) -->
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Tipo programación <span class="text-red-500">*</span>
                </label>
                @if (habilitacion().habilitarTipoCita) {
                  <p-dropdown
                    [ngModel]="form.nmconsecutivoTipoCita"
                    (ngModelChange)="
                      form.nmconsecutivoTipoCita = $event; onTipoCitaChange()
                    "
                    [options]="tiposCitaFiltrados()"
                    optionLabel="dstipo"
                    optionValue="nmconsecutivo"
                    placeholder="Seleccione"
                    [filter]="true"
                    filterBy="dstipo"
                    [style]="{ width: '100%' }"
                    appendTo="body"
                  >
                  </p-dropdown>
                } @else {
                  <input
                    pInputText
                    [value]="
                      cita()?.tipoCita?.dstipo || cita()?.dstipoCita || '-'
                    "
                    readonly
                    class="w-full"
                  />
                }
              </div>

              <!-- Estado de la cita -->
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1"
                  >Estado de la cita</label
                >
                <input
                  pInputText
                  [value]="cita()?.dsestado || cita()?.cdestado || '-'"
                  readonly
                  class="w-full"
                  [style]="{ color: estadoColor() }"
                />
              </div>

              <!-- Enlace de Teams (legacy: rbgSincronizacionOutlook): oculto para INFORME -->
              @if (visibility().mostrarSincronizacionOutlook) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Enlace de Teams <span class="text-red-500">*</span>
                  </label>
                  @if (habilitacion().habilitarCampos) {
                    <div class="flex flex-wrap gap-4 mt-1">
                      <div class="flex items-center">
                        <p-radioButton
                          name="snEnlaceTeamsView"
                          value="S"
                          [(ngModel)]="form.snEnlaceTeams"
                          (ngModelChange)="onEnlaceTeamsChange($event)"
                          inputId="teamsViewSi"
                        >
                        </p-radioButton>
                        <label for="teamsViewSi" class="ml-2">Sí</label>
                      </div>
                      <div class="flex items-center">
                        <p-radioButton
                          name="snEnlaceTeamsView"
                          value="N"
                          [(ngModel)]="form.snEnlaceTeams"
                          (ngModelChange)="onEnlaceTeamsChange($event)"
                          inputId="teamsViewNo"
                        >
                        </p-radioButton>
                        <label for="teamsViewNo" class="ml-2">No</label>
                      </div>
                    </div>
                  } @else {
                    <div class="flex flex-wrap gap-4 mt-1">
                      <div class="flex items-center">
                        <p-radioButton
                          name="snEnlaceTeamsReadonly"
                          value="S"
                          [ngModel]="cita()?.snenlaceTeams || 'N'"
                          inputId="teamsReadonlySi"
                          [disabled]="true"
                        >
                        </p-radioButton>
                        <label for="teamsReadonlySi" class="ml-2">Sí</label>
                      </div>
                      <div class="flex items-center">
                        <p-radioButton
                          name="snEnlaceTeamsReadonly"
                          value="N"
                          [ngModel]="cita()?.snenlaceTeams || 'N'"
                          inputId="teamsReadonlyNo"
                          [disabled]="true"
                        >
                        </p-radioButton>
                        <label for="teamsReadonlyNo" class="ml-2">No</label>
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- ======================================== -->
              <!-- CAMPOS DINÁMICOS POR TIPO DE CITA (EDIT/VIEW) -->
              <!-- ORDEN LEGACY: Beneficiario -> Centro Trabajo -> Tarea -> Contacto -> Fecha/Hora -->
              <!-- ======================================== -->

              <!-- Beneficiario/Cliente: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO, etc. -->
              @if (visibility().mostrarBeneficiario) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Cliente <span class="text-red-500">*</span>
                  </label>
                  <div
                    class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
                  >
                    @if (habilitacion().habilitarCampos) {
                      <!-- Contrato -->
                      <input
                        pInputText
                        [(ngModel)]="form.dscontratoBeneficiario"
                        placeholder="Contrato"
                        readonly
                        class="w-full sm:w-28 cursor-pointer"
                        (click)="abrirBusquedaCliente()"
                      />
                      <!-- Identificación -->
                      <input
                        pInputText
                        [(ngModel)]="form.dsidentificacionBeneficiario"
                        placeholder="Identificación"
                        readonly
                        class="w-full sm:w-28 cursor-pointer"
                        (click)="abrirBusquedaCliente()"
                      />
                      <!-- Nombre Comercial -->
                      <input
                        pInputText
                        [(ngModel)]="form.dsnombreBeneficiario"
                        placeholder="Nombre"
                        readonly
                        class="w-full sm:flex-1 min-w-0 cursor-pointer"
                        (click)="abrirBusquedaCliente()"
                      />
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar cliente"
                        (click)="abrirBusquedaCliente()"
                      ></button>
                    } @else {
                      <input
                        pInputText
                        [value]="cita()?.nombreBeneficiario || '-'"
                        readonly
                        class="flex-1 min-w-0"
                      />
                    }
                  </div>
                </div>
              }

              <!-- PPR (Profesional) - para tipo: SEGUIMIENTO_INTEGRAL_CLIENTE (25) -->
              <!-- Legacy: tblSelectPpr con stbNamePpr (nombre) + stbMailPpr (correo) + siBuscarPpr (lupa) + siAgregaPpr (+) -->
              @if (visibility().mostrarPPR) {
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Nombre del profesional <span class="text-red-500">*</span>
                  </label>
                  @if (habilitacion().habilitarCampos) {
                    <input
                      pInputText
                      [(ngModel)]="form.dsnombrePPR"
                      placeholder="Buscar profesional"
                      readonly
                      class="w-full"
                    />
                  } @else {
                    <input
                      pInputText
                      [value]="cita()?.nombreProfesional || '-'"
                      readonly
                      class="w-full"
                    />
                  }
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Correo</label
                  >
                  <div class="flex gap-2 min-w-0">
                    @if (habilitacion().habilitarCampos) {
                      <input
                        pInputText
                        [(ngModel)]="form.dscorreoPPR"
                        readonly
                        class="flex-1 min-w-0"
                      />
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar profesional"
                        (click)="abrirBusquedaPPR()"
                      ></button>
                      <button
                        pButton
                        icon="pi pi-plus"
                        class="p-button-text min-w-[44px] min-h-[44px]"
                        pTooltip="Adicionar contactos"
                        (click)="agregarContactoPPR()"
                      ></button>
                    } @else {
                      <input
                        pInputText
                        [value]="'-'"
                        readonly
                        class="flex-1 min-w-0"
                      />
                    }
                  </div>
                </div>

                <!-- Fila 2: Contacto adicional (legacy: trMailAdd) - inicialmente oculta -->
                @if (
                  mostrarContactoAdicionalPPR && habilitacion().habilitarCampos
                ) {
                  <div>
                    <label class="block text-sm font-medium text-gray-600 mb-1"
                      >Nombre Contacto</label
                    >
                    <input
                      pInputText
                      [(ngModel)]="form.dsnombreContactoPPR"
                      (input)="form.dsnombreContactoPPR = sanitizeText(form.dsnombreContactoPPR)"
                      class="w-full"
                      maxlength="100"
                      placeholder="Nombre del contacto"
                    />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-600 mb-1"
                      >Correo</label
                    >
                    <div class="flex gap-2 min-w-0">
                      <input
                        pInputText
                        [(ngModel)]="form.dscorreoContactoPPR"
                        (keypress)="emailKeypress($event)"
                        (input)="form.dscorreoContactoPPR = sanitizeEmail(form.dscorreoContactoPPR)"
                        class="flex-1 min-w-0"
                        maxlength="100"
                        placeholder="Correo del contacto"
                      />
                      <button
                        pButton
                        icon="pi pi-times"
                        class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                        pTooltip="Eliminar contacto"
                        (click)="eliminarContactoPPR()"
                      ></button>
                    </div>
                  </div>
                }
              }

              <!-- Centro de Trabajo: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO -->
              @if (visibility().mostrarCentroTrabajo) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Centro de trabajo</label
                  >
                  <div
                    class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
                  >
                    @if (habilitacion().habilitarCampos) {
                      <input
                        pInputText
                        [(ngModel)]="form.dsnombreCentroTrabajo"
                        placeholder="Centro de trabajo"
                        readonly
                        class="w-full sm:flex-1 min-w-0 cursor-pointer"
                        (click)="abrirBusquedaCentroTrabajo()"
                      />
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar centro de trabajo"
                        (click)="abrirBusquedaCentroTrabajo()"
                      ></button>
                    } @else {
                      <input
                        pInputText
                        [value]="cita()?.dscentroTrabajo || '-'"
                        readonly
                        class="flex-1 min-w-0"
                      />
                    }
                  </div>
                </div>
              }

              <!-- Tarea: CAMPO_COMPLEMENTARIO, INFORME_COMPLEMENTARIO, CITA_TENTATIVA, TUTORIA -->
              @if (visibility().mostrarTarea) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Nombre Tarea <span class="text-red-500">*</span>
                  </label>
                  <div
                    class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
                  >
                    @if (habilitacion().habilitarCampos) {
                      <input
                        pInputText
                        [(ngModel)]="form.dsnombreTarea"
                        placeholder="Seleccione una tarea"
                        readonly
                        class="w-full sm:flex-1 min-w-0 cursor-pointer"
                        (click)="abrirBusquedaTarea()"
                      />
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar tarea"
                        (click)="abrirBusquedaTarea()"
                      ></button>
                    } @else {
                      <input
                        pInputText
                        [value]="cita()?.dstarea || '-'"
                        readonly
                        class="flex-1 min-w-0"
                      />
                    }
                  </div>
                </div>
              }

              <!-- ======================================== -->
              <!-- FIN CAMPOS DINÁMICOS ANTES DE CONTACTO -->
              <!-- ======================================== -->

              <!-- Contacto cita (legacy: stbContactName + siLookUp) 
                   CAMPO y Línea AT siempre; INFORME nunca; demás solo con Teams = Sí (resolverVisibilidadContactos)
                   Los campos de contacto son READONLY - solo se modifican con la lupa -->
              @if (visibility().mostrarContactos) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Contacto <span class="text-red-500">*</span>
                  </label>
                  <div
                    class="flex flex-col sm:flex-row sm:items-center gap-2 min-w-0"
                  >
                    @if (habilitacion().habilitarCampos) {
                      <input
                        pInputText
                        [(ngModel)]="form.dsnombreContacto"
                        placeholder="Haga click para abrir la lista de Contactos del cliente"
                        readonly
                        class="w-full sm:flex-1 min-w-0 cursor-pointer"
                        (click)="abrirBusquedaContacto()"
                      />
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar contacto"
                        (click)="abrirBusquedaContacto()"
                      ></button>
                    } @else {
                      <input
                        pInputText
                        [value]="cita()?.dsnombreContacto || '-'"
                        readonly
                        class="w-full sm:flex-1"
                      />
                    }
                  </div>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Teléfono fijo</label
                  >
                  @if (habilitacion().habilitarCampos) {
                    <input
                      pInputText
                      [(ngModel)]="form.dstelefonoContacto"
                      readonly
                      class="w-full"
                    />
                  } @else {
                    <input
                      pInputText
                      [value]="cita()?.dstelefonoContacto || '-'"
                      readonly
                      class="w-full"
                    />
                  }
                </div>

                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Teléfono celular</label
                  >
                  @if (habilitacion().habilitarCampos) {
                    <input
                      pInputText
                      [(ngModel)]="form.dscelularContacto"
                      readonly
                      class="w-full"
                    />
                  } @else {
                    <input
                      pInputText
                      [value]="cita()?.dscelularContacto || '-'"
                      readonly
                      class="w-full"
                    />
                  }
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Email</label
                  >
                  @if (habilitacion().habilitarCampos) {
                    <input
                      pInputText
                      [(ngModel)]="form.dsemailContacto"
                      readonly
                      class="w-full"
                    />
                  } @else {
                    <input
                      pInputText
                      [value]="cita()?.dsemailContacto || '-'"
                      readonly
                      class="w-full"
                    />
                  }
                </div>
              }

              <!-- Fecha y Hora (legacy: sdfAppointmentDate, stpAppointmentTime) -->
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Fecha cita (aaaa/mm/dd) <span class="text-red-500">*</span>
                </label>
                @if (habilitacion().habilitarCampos) {
                  <p-datepicker
                    [(ngModel)]="form.fechaCita"
                    dateFormat="yy/mm/dd"
                    [showIcon]="true"
                    [style]="{ width: '100%' }"
                    appendTo="body"
                  >
                  </p-datepicker>
                } @else {
                  <input
                    pInputText
                    [value]="formatFecha(cita()?.feprogramacion)"
                    readonly
                    class="w-full"
                  />
                }
              </div>
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Hora de inicio (HH:MM) <span class="text-red-500">*</span>
                </label>
                @if (habilitacion().habilitarCampos) {
                  <p-datepicker
                    [(ngModel)]="form.horaInicio"
                    [timeOnly]="true"
                    hourFormat="24"
                    [showIcon]="true"
                    [stepMinute]="1"
                    [style]="{ width: '100%' }"
                    appendTo="body"
                  >
                  </p-datepicker>
                  <app-hora-hint [id]="'cita-hora-inicio-ayuda-2'" />
                } @else {
                  <input
                    pInputText
                    [value]="formatHora(cita()?.feprogramacion)"
                    readonly
                    class="w-full"
                  />
                }
              </div>

              <!-- Duración -->
              <div>
                <label class="block text-sm font-medium text-gray-600 mb-1">
                  Duración <span class="text-red-500">*</span>
                </label>
                @if (habilitacion().habilitarDuracion) {
                  <p-datepicker
                    [(ngModel)]="form.duracion"
                    [timeOnly]="true"
                    hourFormat="24"
                    [showIcon]="true"
                    [stepMinute]="1"
                    [defaultDate]="defaultDuracion"
                    [style]="{ width: '100%' }"
                    (ngModelChange)="onDuracionChange($event)"
                    appendTo="body"
                  >
                  </p-datepicker>
                } @else {
                  <input
                    pInputText
                    [value]="
                      formatDuracion(
                        cita()?.nmhorasCita ??
                          (form.duracion
                            ? form.duracion.getHours() +
                              form.duracion.getMinutes() / 60
                            : 0)
                      )
                    "
                    readonly
                    class="w-full"
                  />
                }
              </div>

              <!-- Cantidad programada: SOLO visible para citas de SERVICIO (legacy: setVisibleScheduledQty(isServiceAppointment())) -->
              @if (visibility().mostrarCantidadProgramada) {
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Cantidad programada <span class="text-red-500">*</span>
                  </label>
                  @if (habilitacion().habilitarCantidad) {
                    <div class="p-inputgroup">
                      <p-inputNumber
                        appDecimalComa
                        [(ngModel)]="form.nmcantidadProgramada"
                        [locale]="localeNumerico"
                        [min]="0.01"
                        [minFractionDigits]="0"
                        [maxFractionDigits]="maxDecimalesCantidad"
                        [useGrouping]="false"
                        ariaDescribedBy="ayuda-cantidad-programada-detalle"
                        placeholder="0,00"
                        inputStyleClass="w-full"
                      />
                      <span class="p-inputgroup-addon">{{
                        cita()?.dsunidadMedida ||
                          ordenServicioDetalle()?.unidadMedida ||
                          'HORAS'
                      }}</span>
                    </div>
                    <app-decimal-hint
                      id="ayuda-cantidad-programada-detalle"
                      ejemplo="1,5"
                    />
                  } @else if (mode() !== 'create') {
                    <input
                      pInputText
                      [value]="
                        formatDecimal(
                          cita()?.nmcantidadProgramada ?? cita()?.nmhorasCita
                        ) +
                        ' ' +
                        (cita()?.dsunidadMedida ||
                          ordenServicioDetalle()?.unidadMedida ||
                          'HORAS')
                      "
                      readonly
                      class="w-full"
                    />
                  }
                </div>
              }

              <!-- Dirección: solo visible para tipo CAMPO -->
              @if (visibility().mostrarDireccion) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Dirección</label
                  >
                  <div class="flex gap-2 min-w-0">
                    <input
                      pInputText
                      [(ngModel)]="form.dsdireccion"
                      [readonly]="!habilitacion().habilitarCampos"
                      (input)="form.dsdireccion = sanitizeText(form.dsdireccion)"
                      class="flex-1 min-w-0"
                    />
                    @if (habilitacion().habilitarCampos) {
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar dirección"
                        (click)="abrirBusquedaDireccion()"
                      ></button>
                    }
                  </div>
                </div>
              }

              <!-- Periodicidad: se oculta para CAMPO_COMPLEMENTARIO e INFORME_COMPLEMENTARIO -->
              @if (!visibility().ocultarPeriodicidad) {
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Periodicidad</label
                  >
                  <p-dropdown
                    [(ngModel)]="form.tipoperiodicidad"
                    [options]="periodicidades"
                    optionLabel="label"
                    optionValue="value"
                    [filter]="true"
                    filterBy="label"
                    placeholder="--Sin periodicidad--"
                    [disabled]="!habilitacion().habilitarPeriodicidad"
                    [style]="{ width: '100%' }"
                    [styleClass]="
                      !habilitacion().habilitarPeriodicidad
                        ? 'disabled-dropdown'
                        : ''
                    "
                    appendTo="body"
                  >
                  </p-dropdown>
                </div>
              }

              <!-- Observaciones (legacy: staNotes - ubicado después de Periodicidad) -->
              <div class="md:col-span-2">
                <label class="block text-sm font-medium text-gray-600 mb-1"
                  >Observación</label
                >
                <textarea
                  pInputTextarea
                  [(ngModel)]="form.dsobservaciones"
                  [readonly]="!habilitacion().habilitarCampos"
                  (input)="form.dsobservaciones = sanitizeTextarea(form.dsobservaciones)"
                  rows="3"
                  class="w-full"
                >
                </textarea>
              </div>

              <!-- ======================================== -->
              <!-- CAMPOS DINÁMICOS AL FINAL (Virtual, Grupo, Formación) -->
              <!-- ======================================== -->

              <!-- Virtual: TUTORIA_PEC_PAI, TUTORIA_CAMPO - radio buttons igual que en modo CREATE -->
              @if (visibility().mostrarVirtual) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1">
                    Atención virtual <span class="text-red-500">*</span>
                  </label>
                  <div class="flex flex-wrap gap-4 mt-1">
                    <div class="flex items-center">
                      <p-radioButton
                        name="snvirtualEdit"
                        value="S"
                        [(ngModel)]="form.snvirtual"
                        inputId="virtualSiEdit"
                        [disabled]="!habilitacion().habilitarCampos"
                        (ngModelChange)="onVirtualChange($event)"
                      ></p-radioButton>
                      <label for="virtualSiEdit" class="ml-2">Sí</label>
                    </div>
                    <div class="flex items-center">
                      <p-radioButton
                        name="snvirtualEdit"
                        value="N"
                        [(ngModel)]="form.snvirtual"
                        inputId="virtualNoEdit"
                        [disabled]="!habilitacion().habilitarCampos"
                        (ngModelChange)="onVirtualChange($event)"
                      ></p-radioButton>
                      <label for="virtualNoEdit" class="ml-2">No</label>
                    </div>
                  </div>
                </div>
              }

              <!-- Panel Transporte - visible cuando Virtual=NO para tipos 40,41 -->
              <!-- Legacy: mostrarOcultarTransporte() en CrearCitaAdministrativaViewImpl.java -->
              @if (visibility().mostrarTransporte) {
                <app-panel-transporte
                  [data]="transporteData"
                  (dataChange)="onTransporteDataChange($event)"
                />
              }

              <!-- Grupo de Estudio: GRUPO_ESTUDIO -->
              <!-- Legacy: mostrarOcultarGrupoEstudio() muestra slNumeroGrupoEstu + slLineaEstudio + slTema -->
              @if (visibility().mostrarGrupoEstudio) {
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Numero de linea de estudio</label
                  >
                  <p-dropdown
                    [(ngModel)]="form.nmgrupoEstudio"
                    [options]="gruposEstudio"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione..."
                    [filter]="true"
                    filterBy="label"
                    [disabled]="!habilitacion().habilitarCampos"
                    [style]="{ width: '100%' }"
                    appendTo="body"
                  >
                  </p-dropdown>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Linea de estudio</label
                  >
                  <input
                    pInputText
                    [(ngModel)]="form.dslineaEstudio"
                    [readonly]="!habilitacion().habilitarCampos"
                    (input)="form.dslineaEstudio = sanitizeText(form.dslineaEstudio)"
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Tema de estudio</label
                  >
                  <input
                    pInputText
                    [(ngModel)]="form.dstema"
                    [readonly]="!habilitacion().habilitarCampos"
                    (input)="form.dstema = sanitizeText(form.dstema)"
                    class="w-full"
                  />
                </div>
              }

              <!-- Formacion Tecnica: FORMACION_TECNICA -->
              <!-- Legacy: mostrarOcultarFormacionTecnica() SOLO muestra slbTipoFormacio (sin Tema) -->
              @if (visibility().mostrarFormacionTecnica) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Tipo de formacion</label
                  >
                  <p-dropdown
                    [(ngModel)]="form.cdtipoFormacion"
                    [options]="tiposFormacion"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione..."
                    [filter]="true"
                    filterBy="label"
                    [disabled]="!habilitacion().habilitarCampos"
                    [style]="{ width: '100%' }"
                    scrollHeight="200px"
                    panelStyleClass="dropdown-open-up"
                    appendTo="body"
                  >
                  </p-dropdown>
                </div>
              }

              <!-- Investigacion: INVESTIGACION_APLICADA -->
              <!-- Legacy: mostrarOcultarInvestigacion() SOLO muestra slbTipoInvestigacion (sin Tema) -->
              @if (visibility().mostrarInvestigacion) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Tipo de investigación</label
                  >
                  <p-dropdown
                    [(ngModel)]="form.cdtipoInvestigacion"
                    [options]="tiposInvestigacion"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Seleccione..."
                    [filter]="true"
                    filterBy="label"
                    [disabled]="!habilitacion().habilitarCampos"
                    [style]="{ width: '100%' }"
                    scrollHeight="200px"
                    panelStyleClass="dropdown-open-up"
                    appendTo="body"
                  >
                  </p-dropdown>
                </div>
              }

              <!-- Unidad de Negocio: CONTENIDOS_TECNICOS (54) -->
              <!-- Legacy: Abre buscador con Código/Nombre de TPSC_UNIDADES_NEGOCIO -->
              @if (visibility().mostrarUnidadNegocio) {
                <div class="md:col-span-2">
                  <label class="block text-sm font-medium text-gray-600 mb-1"
                    >Unidad de negocio</label
                  >
                  <div class="flex gap-2 min-w-0">
                    <input
                      pInputText
                      [(ngModel)]="form.dsunidadNegocio"
                      placeholder="Seleccione una unidad de negocio"
                      [readonly]="true"
                      [class.cursor-pointer]="habilitacion().habilitarCampos"
                      class="flex-1 min-w-0"
                      (click)="
                        habilitacion().habilitarCampos &&
                          abrirBusquedaUnidadNegocio()
                      "
                    />
                    @if (habilitacion().habilitarCampos) {
                      <button
                        pButton
                        icon="pi pi-search"
                        class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
                        pTooltip="Buscar unidad de negocio"
                        (click)="abrirBusquedaUnidadNegocio()"
                      ></button>
                    }
                  </div>
                </div>
              }
            </div>
          </p-fieldset>
        </div>
      }

      <ng-template pTemplate="footer">
        <!-- Orden estándar: Cerrar | Cancelar programación | Cumplimiento | Grabar -->
        <div
          class="flex flex-wrap justify-end sm:justify-start gap-2 sm:gap-3 w-full"
        >
          <p-button
            label="Cerrar"
            icon="pi pi-times"
            [outlined]="true"
            styleClass="w-full sm:w-auto min-h-[44px]"
            (onClick)="visible = false; onClose.emit()"
          >
          </p-button>

          @if (visibility().mostrarCancelar) {
            <p-button
              label="Cancelar programación"
              icon="pi pi-times-circle"
              severity="danger"
              [outlined]="true"
              styleClass="w-full sm:w-auto min-h-[44px]"
              [disabled]="!visibility().habilitarCancelar"
              (onClick)="confirmarCancelacion()"
            >
            </p-button>
          }

          @if (visibility().mostrarCumplir) {
            <p-button
              label="Ingresar cumplimiento"
              icon="pi pi-check-circle"
              severity="success"
              [outlined]="true"
              styleClass="w-full sm:w-auto min-h-[44px]"
              [disabled]="!visibility().habilitarCumplir"
              (onClick)="cumplir()"
            >
            </p-button>
          }

          @if (visibility().mostrarGuardar) {
            <p-button
              label="Grabar"
              icon="pi pi-check"
              styleClass="w-full sm:w-auto min-h-[44px]"
              (onClick)="guardar()"
            >
            </p-button>
          }
        </div>
      </ng-template>
    </p-dialog>

    <p-confirmDialog></p-confirmDialog>

    <!-- Loading global para carga de formulario -->
    <app-loading-overlay [blocked]="loadingFormulario() || loadingDetalle()" />

    <!-- Loading global para carga de contactos -->
    <app-loading-overlay [blocked]="loadingContactos()" />

    <!-- Diálogo de búsqueda de contactos del centro de trabajo -->
    @if (dialogContactosVisible) {
      <app-contactos-trabajo-dialog
        [contactos]="contactosCentroTrabajo()"
        [paginacionServidor]="facade.paginacionContactos()"
        [errorGuardado]="errorGuardadoContactos"
        (onPaginar)="onPaginarContactos($event)"
        [cdpersona]="cita()?.cdpersonaAsesor ?? null"
        (onSelect)="onContactoSeleccionado($event)"
        (onSave)="onContactoCreado($event)"
        (onUpdate)="onContactoModificado($event)"
        (onClose)="dialogContactosVisible = false"
      />
    }

    <!-- Diálogo de cancelación avanzado -->
    @if (dialogCancelarVisible && cita()?.nmconsecutivoProg) {
      <app-cancelar-cita-dialog
        [citaId]="cita()!.nmconsecutivoProg!"
        [cita]="cita()"
        [datosProgramador]="datosProgramador()"
        [cancelarFuturas]="snModifyPeriodicity"
        (onConfirm)="onCancelacionConfirmada($event)"
        (onClose)="dialogCancelarVisible = false"
      />
    }

    <app-gestionar-contactos-informe-dialog
      #contactosInformeDialog
      (cerrado)="onContactosInformeCerrado()" />

    <!-- Diálogo de justificación para citas tardías -->
    <!-- Migrado del legacy: CreateOrUpdateCumplimientoViewImpl.openDialogTardio() -->
    <app-justificacion-tardia-dialog
      [visible]="dialogJustificacionVisible"
      (onConfirm)="onJustificacionConfirmada($event)"
      (onClose)="onJustificacionCancelada()"
    />

    <!-- ============================================================ -->
    <!-- DIALOGOS DE BUSQUEDA (Cliente, Centro de Trabajo, Tarea) -->
    <!-- Migrado del legacy: BuscadorBeneficiariosViewImpl, UtilidadesBuscadores -->
    <!-- ============================================================ -->

    <!-- Búsqueda de Cliente/Beneficiario -->
    @if (dialogBuscarClienteVisible) {
      <app-busqueda-cliente-dialog
        (onSelect)="onClienteSeleccionado($event)"
        (onClose)="dialogBuscarClienteVisible = false"
      />
    }

    <!-- Búsqueda de Centro de Trabajo -->
    @if (dialogBuscarCentroTrabajoVisible) {
      <app-busqueda-centro-trabajo-dialog
        [nmconsecutivoBeneficiario]="form.nmconsecutivoBeneficiario"
        [nombreBeneficiario]="form.dsnombreBeneficiario"
        (onSelect)="onCentroTrabajoSeleccionado($event)"
        (onClose)="dialogBuscarCentroTrabajoVisible = false"
      />
    }

    <!-- Búsqueda de Tarea -->
    @if (dialogBuscarTareaVisible) {
      <app-busqueda-tarea-dialog
        (onSelect)="onTareaSeleccionada($event)"
        (onClose)="dialogBuscarTareaVisible = false"
      />
    }

    <!-- Búsqueda de Unidad de Negocio - para CONTENIDOS_TECNICOS (54) -->
    @if (dialogBuscarUnidadNegocioVisible) {
      <app-busqueda-unidad-negocio-dialog
        (onSelect)="onUnidadNegocioSeleccionada($event)"
        (onClose)="dialogBuscarUnidadNegocioVisible = false"
      />
    }

    <!-- Búsqueda de Profesional (PPR) - para SEGUIMIENTO_INTEGRAL_CLIENTE (25) -->
    @if (dialogBuscarProfesionalVisible) {
      <app-busqueda-profesional-dialog
        [origen]="BuscadorProfesionalOrigen.PROFESIONALES"
        (onSelect)="onProfesionalSeleccionado($event)"
        (onClose)="dialogBuscarProfesionalVisible = false"
      />
    }

    <!-- Formateador de Dirección - Reutilizado de admin personas -->
    <!-- Legacy: IngresarDireccionFormateadaActivity.mostrarDialogoDireccion() -->
    <app-formateador-direccion
      #formateadorDireccion
      [tiposVia]="tiposVia()"
      [apendices]="apendices()"
      [cardinalidades]="cardinalidades()"
      (direccionFormateada)="onDireccionFormateada($event)"
    />

    <!-- Modal Registrar Cumplimiento -->
    @if (dialogCumplimientoVisible()) {
      <app-formulario-cumplimiento
        [visible]="dialogCumplimientoVisible()"
        [programacion]="programacionParaCumplimiento()"
        [saldoActual]="saldoCumplimiento()"
        [loading]="loadingCumplimiento()"
        [esTipoCampo]="esTipoCampo()"
        [esTipoInforme]="esTipoInforme()"
        [requiereJustificacion]="requiereJustificacion()"
        [justificaciones]="justificacionesCumplimiento()"
        [municipioOrigenInicial]="municipioOrigenInicialCumplimiento()"
        [municipioEntregaInicial]="municipioEntregaInicialCumplimiento()"
        [mostrarBotonDescargarActa]="mostrarBotonDescargarActa()"
        [descargandoActa]="descargandoActaAsociada()"
        (visibleChange)="onDialogCumplimientoVisibleChange($event)"
        (guardar)="onGuardarCumplimiento($event)"
        (descargarActa)="onDescargarActaAsociada()"
        (cancelar)="onCancelarCumplimientoDesdeAgenda()"
        (fechaCumplimientoChange)="onFechaCumplimientoChange($event)"
        (reportarAlertaTemprana)="reportarAlertaTemprana()"
        (verHistorial)="onVerHistorialCumplimientos()"
      >
      </app-formulario-cumplimiento>

      <!-- Historial de Cumplimientos Dialog -->
      <app-historial-cumplimientos-dialog
        [visible]="historialCumplimientosVisible()"
        [cumplimientos]="historialCumplimientos()"
        (cerrar)="historialCumplimientosVisible.set(false)"
        (recargarHistorial)="onVerHistorialCumplimientos()"
      >
      </app-historial-cumplimientos-dialog>
    }
  `
})
export class CitaDialogComponent implements OnInit, OnChanges {
  readonly BuscadorProfesionalOrigen = BuscadorProfesionalOrigen;
  readonly maxObservaciones = MAX_OBSERVACIONES_CITA;

  // Sanitización XSS/SQL para campos de texto libre (skill seguridad-girop §3)
  sanitizeText = sanitizeText;
  sanitizeTextarea = sanitizeTextarea;
  sanitizeEmail = sanitizeEmail;
  emailKeypress = emailKeypress;

  /** Campos numéricos con decimales: coma decimal, máximo 2 posiciones. */
  readonly localeNumerico = LOCALE_NUMERICO;
  readonly maxDecimalesCantidad = MAX_DECIMALES_CANTIDAD;

  // === Inputs ===
  cita = input<ProgramacionServicio | null>(null);
  mode = input<CitaMode>('view');
  tiposCita = input<TipoCita[]>([]);
  loadingDetalle = input<boolean>(false);

  /**
   * Contexto de orden de servicio (opcional).
   * Cuando se proporciona, la cita es de tipo CAMPO (17) o INFORME (18)
   * y los datos de la orden se muestran en un acordeón de solo lectura.
   * Legacy: SchedulingServicesCalendarActivity.java
   */
  ordenServicioDetalle = input<OrdenServicioDetalleProgramar | null>(null);

  // === Outputs ===
  onClose = output<void>();
  onSave = output<ProgramacionServicioRequest>();
  onCancel = output<CancelarCitaResult>();
  onCumplir = output<number>();
  onCumplimientoRegistrado = output<number>(); // Emite cuando se registra cumplimiento exitosamente
  onRegresarDesdeCumplimiento = output<void>();

  // === Services ===
  private readonly confirmationService = inject(ConfirmationService);
  private readonly messageService = inject(MessageService);
  private readonly beneficiarioRepository = inject(BeneficiarioRepository);
  private readonly nomenclaturaRepository = inject(NomenclaturaRepository);
  private readonly cumplimientoRepo = inject(CumplimientoRepository);
  private readonly catalogoRepository = inject(CatalogoRepository);

  // === Facade ===
  readonly facade = inject(CitaFacade);

  // === State ===
  visible = false; // Empieza oculto para evitar parpadeo durante carga
  dialogCancelarVisible = false; // Diálogo de cancelación avanzado
  dialogJustificacionVisible = false; // Diálogo de justificación para citas tardías
  private suprimirOnHide = false;
  private detalleCerradoParaCumplimiento = false;
  /** true mientras el modal de contactos del informe está abierto y la cita espera para cerrarse. */
  private cerrarCitaAlCerrarContactos = false;

  // === Modal Registrar Cumplimiento ===
  dialogCumplimientoVisible = signal(false);
  programacionParaCumplimiento = signal<ProgramacionPendiente | null>(null);

  // === Historial de Cumplimientos ===
  historialCumplimientosVisible = signal(false);
  historialCumplimientos = signal<HistorialCumplimiento[]>([]);
  loadingHistorial = signal(false);
  saldoCumplimiento = signal(0);
  loadingCumplimiento = signal(false);
  esTipoCampo = signal(false);
  esTipoInforme = signal(false);
  requiereJustificacion = signal(false);
  justificacionesCumplimiento = signal<{ label: string; value: string }[]>([]);
  // Municipios precargados para el formulario de cumplimiento
  municipioOrigenInicialCumplimiento = signal<MunicipioPrecargado | null>(null);
  municipioEntregaInicialCumplimiento = signal<MunicipioPrecargado | null>(
    null
  );
  mostrarBotonDescargarActa = signal(false);
  descargandoActaAsociada = signal(false);
  private nmconsecutivoCumplimientoDescargable: number | null = null;

  // Justificación temporal (se agrega al request si se confirma)
  private justificacionTardia: JustificacionTardiaResult | null = null;

  // Effect para mostrar el diálogo solo cuando termine la carga
  private readonly visibilityEffect = effect(() => {
    const loading = this.loadingFormulario();
    const detalleLoading = this.loadingDetalle();
    const pendientePeriodicidad = this.facade.pendienteConfirmPeriodicidad();
    const currentMode = this.mode();
    const hasCita = this.cita() !== null;

    if (this.detalleCerradoParaCumplimiento) {
      return;
    }

    // En modo create no hay carga de datos, mostrar inmediatamente
    if (currentMode === 'create') {
      this.visible = true;
      return;
    }

    // En modo edit/view, mostrar cuando hay cita, no está cargando y no hay confirm pendiente
    if (hasCita && !loading && !detalleLoading && !pendientePeriodicidad) {
      this.visible = true;
    }
  });

  // === Diálogos de búsqueda ===
  dialogBuscarClienteVisible = false;
  dialogBuscarCentroTrabajoVisible = false;
  dialogBuscarTareaVisible = false;
  dialogBuscarUnidadNegocioVisible = false;
  dialogBuscarProfesionalVisible = false;

  @ViewChild('formateadorDireccion')
  formateadorDireccion!: FormateadorDireccionComponent;

  /** Fecha default para duración: 00:00 (para que el picker no muestre hora actual) */
  readonly defaultDuracion = (() => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
  })();

  // === Delegación al Facade (el template sigue usando 'form' sin cambios) ===
  get form(): CitaFormModel {
    return this.facade.form;
  }
  get loadingContactos() {
    return this.facade.loadingContactos;
  }
  get loadingFormulario() {
    return this.facade.loadingFormulario;
  }
  get contactosCentroTrabajo() {
    return this.facade.contactosCentroTrabajo;
  }
  get periodicidades() {
    return this.facade.periodicidades();
  }
  get gruposEstudio() {
    return this.facade.gruposEstudio;
  }
  get tiposFormacion() {
    return this.facade.tiposFormacion;
  }
  get tiposInvestigacion() {
    return this.facade.tiposInvestigacion;
  }
  get labels() {
    return this.facade.labels;
  }
  get tooltips() {
    return this.facade.tooltips;
  }
  get transporteData(): TransporteData {
    return this.facade.transporteData;
  }
  set transporteData(value: TransporteData) {
    this.facade.transporteData = value;
  }
  get tipoCitaSeleccionado() {
    return this.facade.tipoCitaSeleccionado;
  }
  get virtualSeleccionado() {
    return this.facade.virtualSeleccionado;
  }
  get datosProgramador() {
    return this.facade.datosProgramador;
  }
  get snModifyPeriodicity() {
    return this.facade.snModifyPeriodicity;
  }
  set snModifyPeriodicity(value: 'S' | 'N') {
    this.facade.snModifyPeriodicity = value;
  }
  get mostrarContactoAdicionalPPR() {
    return this.facade.mostrarContactoAdicionalPPR;
  }

  /** Legacy: isServiceAppointment() verifica dsuso_cita == 'SERVICIO' */
  esTipoServicio(): boolean {
    return this.facade.esTipoServicio();
  }
  set mostrarContactoAdicionalPPR(value: boolean) {
    this.facade.mostrarContactoAdicionalPPR = value;
  }
  get tiposVia() {
    return this.facade.tiposVia;
  }
  get apendices() {
    return this.facade.apendices;
  }
  get cardinalidades() {
    return this.facade.cardinalidades;
  }
  get configuracion() {
    return this.facade.configuracion;
  }

  // Dialog de búsqueda de contactos
  dialogContactosVisible = false;
  /** Legacy: tras registrar un cumplimiento Final de tipo INFORME se gestionan los contactos del informe. */
  @ViewChild('contactosInformeDialog') contactosInformeDialog?: GestionarContactosInformeDialogComponent;
  /** Se incrementa cuando falla guardar un contacto: el diálogo reabre el formulario con lo digitado. */
  errorGuardadoContactos = 0;
  /** CDPERSONA del cliente elegido en el buscador (Línea AT). */
  private cdpersonaClienteSeleccionado: number | null = null;

  // === Computed: Título del diálogo - Siempre "Programación de la cita" como legacy ===
  dialogTitle = computed(() => {
    // Legacy: appointmentDialogTitle = "Programación de la cita" (siempre igual)
    const baseTitle = this.labels.APPOINTMENT_DIALOG_TITLE;
    const citaId = this.cita()?.nmconsecutivoProg;
    // Mostrar ID solo en modo edit/view (cuando hay una cita existente)
    return citaId ? `${baseTitle} - ID: ${citaId}` : baseTitle;
  });

  // === Computed: Contexto de orden de servicio ===
  /**
   * Indica si la cita se está creando desde una orden de servicio.
   * Cuando es true, se filtran los tipos de cita a solo CAMPO (17) e INFORME (18)
   * y se muestra el acordeón "Detalles de la tarea" con datos de solo lectura.
   */
  esOrdenServicio = computed(() => {
    return !!this.ordenServicioDetalle();
  });

  /**
   * Legacy ServiceAppointmentInterfaceImpl.setAppointmentTypeData (líneas 1319-1354):
   * filtra por USO_CITA_SERVICIO cuando la cita tiene nmconsec_orden_serv_detalle (viene de OS);
   * en el resto de los casos filtra por USO_CITA_ADMIN.
   */
  tiposCitaFiltrados = computed(() => {
    const todos = this.tiposCita();
    const tieneDetalleOS =
      !!this.ordenServicioDetalle() || !!this.cita()?.nmconsecOrdenServDetalle;
    if (tieneDetalleOS) {
      return todos.filter(
        (t) =>
          t.nmconsecutivo === TIPOS_CITA.CAMPO ||
          t.nmconsecutivo === TIPOS_CITA.INFORME
      );
    }
    return todos.filter(
      (t) =>
        t.nmconsecutivo !== TIPOS_CITA.CAMPO &&
        t.nmconsecutivo !== TIPOS_CITA.INFORME
    );
  });

  // === Computed: Color del estado ===
  estadoColor = computed(() => {
    const estado = this.cita()?.cdestado;
    if (!estado) return '#6c757d';

    if (estado === ESTADO_CITA.EJECUTADA) return '#28a745';
    if (estado === ESTADO_CITA.CANCELADA) return '#dc3545';
    return '#007bff';
  });

  /**
   * Computed: Configuración de campos según el tipo de cita seleccionado.
   * Migrado de CrearCitaAdministrativaViewImpl.onListBoxTypeChange()
   */
  camposPorTipo = computed(() => {
    const c = this.cita();
    // Legacy onListBoxTypeChange: la selección actual del dropdown manda sobre
    // el tipo persistido, tanto en create como en edit.
    const tipoCitaDesdeCita =
      c?.nmconsecutivoTipoCita || c?.tipoCita?.nmconsecutivo || 0;
    const tipoCitaDesdeSignal = this.tipoCitaSeleccionado();
    const tipoCitaId = tipoCitaDesdeSignal || tipoCitaDesdeCita;

    return CAMPOS_POR_TIPO_CITA[tipoCitaId] || {};
  });

  // === Computed: Reglas de visibilidad (migrado del legacy) ===
  visibility = computed(() => {
    const c = this.cita();
    const m = this.mode();
    // Legacy onListBoxTypeChange -> setVisibleFields(): la selección actual del
    // dropdown manda sobre el tipo persistido, tanto en create como en edit.
    const tipoCitaDesdeCita =
      c?.nmconsecutivoTipoCita || c?.tipoCita?.nmconsecutivo || 0;
    const tipoCitaDesdeSignal = this.tipoCitaSeleccionado();
    const tipoCitaId = tipoCitaDesdeSignal || tipoCitaDesdeCita;
    const configCampos = CAMPOS_POR_TIPO_CITA[tipoCitaId || 0] || {};

    // CAMPO (17) muestra dirección y Teams (CAMPO_COMPLEMENTARIO NO muestra dirección según legacy)
    const esCampo = tipoCitaId === TIPOS_CITA.CAMPO;

    // Estado de la cita
    const estado = (c?.cdestado || '').toUpperCase().trim();

    const esEditable = c?.sncitaModificable === 'S' || m === 'create';
    // Variables para determinar si el estado permite la acción (visibilidad).
    // Legacy: TPSC_ESTADOS.SNPERMITE_CANCELACION / SNPERMITE_CUMPLIMIENTO.
    const estadoPermiteCancelar = c?.snpermiteCancelacion === 'S';
    const estadoPermiteCumplir = c?.snpermiteCumplimiento === 'S';
    // Variables para determinar si la acción está habilitada (modo view o edit, NO create)
    const esCancelable = estadoPermiteCancelar && m !== 'create';
    const esCumplible = estadoPermiteCumplir && m !== 'create';
    const esEjecutada = ESTADOS_EJECUTADOS.some(
      (e) =>
        estado.toUpperCase() === e ||
        c?.dsestado?.toUpperCase().includes('EJECUTAD')
    );

    // Contactos y Enlace Teams por tipo de cita (legacy: setVisibleContactInfo).
    // Regla única en resolverVisibilidadContactos; reacciona a enlaceTeamsSeleccionado.
    const visibilidadContactos = this.facade.getVisibilidadContactos();

    return {
      mostrarContactos: visibilidadContactos.mostrarContactos,
      mostrarDireccion: esCampo || configCampos.direccion, // Solo CAMPO (17), NO CAMPO_COMPLEMENTARIO (42)
      mostrarSincronizacionOutlook: visibilidadContactos.mostrarEnlaceTeams,
      mostrarEnlaceTeams: visibilidadContactos.mostrarEnlaceTeams,

      // === Campos dinámicos por tipo de cita (legacy: onListBoxTypeChange) ===
      mostrarBeneficiario: !!configCampos.beneficiario,
      mostrarTarea: !!configCampos.tarea,
      mostrarCentroTrabajo: !!configCampos.centroTrabajo,
      mostrarVirtual: !!configCampos.virtual,
      mostrarGrupoEstudio: !!configCampos.grupoEstudio,
      mostrarFormacionTecnica: !!configCampos.formacionTecnica,
      mostrarInvestigacion: !!configCampos.investigacion,
      mostrarUnidadNegocio: !!configCampos.unidadNegocio,
      mostrarPPR: !!configCampos.ppr,
      observacionObligatoria: !!configCampos.observacionObligatoria,
      ocultarPeriodicidad: !!configCampos.ocultarPeriodicidad,
      // Transporte: visible para TUTORIA_PEC_PAI (40) y TUTORIA_CAMPO (41) cuando Virtual = NO
      // Legacy: mostrarOcultarTransporte() en CrearCitaAdministrativaViewImpl.java
      // Usamos el signal virtualSeleccionado para forzar reactividad
      mostrarTransporte:
        (tipoCitaId === TIPOS_CITA.TUTORIA_PEC_PAI ||
          tipoCitaId === TIPOS_CITA.TUTORIA_CAMPO) &&
        this.virtualSeleccionado() === 'N',

      // Cantidad programada: legacy setVisibleScheduledQty(isServiceAppointment()).
      // isServiceAppointment() SOLO verifica DSUSO_CITA == 'SERVICIO' del tipo de
      // cita seleccionado en el catálogo. Sin excepciones por ID de tipo.
      mostrarCantidadProgramada: this.facade.esTipoServicio(),

      // Accordions (legacy: setVisibleFields líneas 1849-1866)
      // Citas ADMIN (sin orden): OCULTAN ambos accordions de orden/cumplimiento
      // Citas SERVICIO (con orden): muestran orden, y cumplimiento solo si EJECUTADA
      mostrarAccordionDetalleOrden: !!c?.nmconsecOrdenServDetalle,
      mostrarAccordionCumplimiento:
        !!c?.nmconsecOrdenServDetalle && esEjecutada,

      // Botones de acción (legacy: Grabar | Cumplimiento | Cancelar programación | Cerrar)
      // No hay botón "Editar" - se entra directo a modo edición
      mostrarGuardar: m === 'create' || (m === 'edit' && esEditable),
      // Botones visibles cuando el estado lo permite (view o edit), habilitados solo en edit
      mostrarCancelar: m !== 'create' && estadoPermiteCancelar,
      // Legacy isFulFillableAppointment(): permite cumplir SIN orden cuando el
      // tipo cita es CAMPO_COMPLEMENTARIO/INFORME_COMPLEMENTARIO.
      // Se exige que TANTO el tipo persistido (tipoCitaDesdeCita) como el tipo
      // actualmente seleccionado en el dropdown (tipoCitaId) sean complementarios:
      //  - si el persistido lo era y el usuario lo cambia a otro tipo -> ocultar
      //  - si el persistido no lo era y el usuario acaba de seleccionarlo -> ocultar
      //    (aún no guardado; `cumplir()` opera sobre `this.cita()` persistida).
      mostrarCumplir:
        m !== 'create' &&
        estadoPermiteCumplir &&
        (!!c?.nmconsecOrdenServDetalle ||
          ((tipoCitaDesdeCita === TIPOS_CITA.CAMPO_COMPLEMENTARIO ||
            tipoCitaDesdeCita === TIPOS_CITA.INFORME_COMPLEMENTARIO) &&
            (tipoCitaId === TIPOS_CITA.CAMPO_COMPLEMENTARIO ||
              tipoCitaId === TIPOS_CITA.INFORME_COMPLEMENTARIO))),
      habilitarCancelar: esCancelable,
      habilitarCumplir: esCumplible,

      // Estado visible en edit y create
      mostrarEstado: m !== 'create'
    };
  });

  // === Computed: Reglas de habilitación (migrado del legacy) ===
  habilitacion = computed(() => {
    const m = this.mode();
    const c = this.cita();
    // Legacy: TPSC_ESTADOS.SNCITA_MODIFICABLE.
    const esEditable = c?.sncitaModificable === 'S' || m === 'create';

    // Tipo de cita actual para reglas específicas.
    // Selección actual manda; el tipo persistido solo se usa como fallback.
    const tipoCitaDesdeCita =
      this.cita()?.nmconsecutivoTipoCita ||
      this.cita()?.tipoCita?.nmconsecutivo ||
      0;
    const tipoCitaDesdeSignal = this.tipoCitaSeleccionado();
    const tipoCita = tipoCitaDesdeSignal || tipoCitaDesdeCita;

    // AUTOAGENDAMIENTO_WHATSAPP (56): duración fija, no editable
    const duracionFija = tipoCita === TIPOS_CITA_IDS.AUTOAGENDAMIENTO_WHATSAPP;
    // Legacy CrearCitaAdministrativaViewImpl.java:2341 -> slbAppointmentType.setEnabled(false)
    // cuando la cita ya es AUTOAGENDAMIENTO_WHATSAPP (edit/view). En create sí se puede elegir.
    const bloqueoTipoAutoagendamiento =
      m !== 'create' &&
      tipoCitaDesdeCita === TIPOS_CITA_IDS.AUTOAGENDAMIENTO_WHATSAPP;

    // Regla legacy: para citas CAMPO/INFORME sólo se permite alternar entre CAMPO<->INFORME
    // y únicamente en estado PROGRAMADA (0015). En otros estados el dropdown queda deshabilitado.
    const citaEsCampoOInforme =
      tipoCitaDesdeCita === TIPOS_CITA_IDS.CAMPO ||
      tipoCitaDesdeCita === TIPOS_CITA_IDS.INFORME;
    const estadoCita = c?.cdestado;
    const bloqueoCampoInformeFueraProgramada =
      m === 'edit' &&
      citaEsCampoOInforme &&
      estadoCita !== ESTADO_CITA.PROGRAMADA;

    // Legacy isServiceAppointment(): DSUSO_CITA == 'SERVICIO' del tipo seleccionado.
    const esTipoServicio = this.facade.esTipoServicio();

    const unidadMedida = (
      this.cita()?.dsunidadMedida ||
      this.ordenServicioDetalle()?.unidadMedida ||
      ''
    )
      .trim()
      .toUpperCase();
    const esUnidadHoras = unidadMedida === 'HORAS';

    return {
      habilitarCampos: m !== 'view' && esEditable,
      // Legacy ServiceAppointmentInterfaceImpl.isEnabledAppointmentType():
      // habilitado en TOKEN_NEW_RECORD o TOKEN_EDIT_RECORD, salvo bloqueo específico
      // para AUTOAGENDAMIENTO_WHATSAPP.
      habilitarTipoCita:
        (m === 'create' || m === 'edit') &&
        esEditable &&
        !bloqueoTipoAutoagendamiento &&
        !bloqueoCampoInformeFueraProgramada,
      habilitarCantidad:
        m !== 'view' && esEditable && esTipoServicio && !esUnidadHoras,
      habilitarPeriodicidad: m === 'create', // Solo en crear
      habilitarGuardar: m !== 'view' && esEditable,
      habilitarDuracion: m !== 'view' && esEditable && !duracionFija // Legacy: stpDuration.setEnabled(false) para AUTOAGENDAMIENTO
    };
  });

  // === Lifecycle ===
  async ngOnInit(): Promise<void> {
    // Sincronizar facade con inputs iniciales
    this.facade.setMode(this.mode());
    this.facade.setTiposCita(this.tiposCita());
    // Cargar configuración (min/max duración, festivos) - legacy: GeneralParameters
    await this.facade.cargarConfiguracion();
    // Cargar datos del usuario actual (programador) para el diálogo de cancelación
    await this.facade.cargarDatosProgramador();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.detalleCerradoParaCumplimiento = false;
    // Sincronizar facade con cambios de inputs
    if (changes['mode']) {
      this.facade.setMode(this.mode());
    }
    if (changes['tiposCita']) {
      this.facade.setTiposCita(this.tiposCita());
    }
    if (changes['cita'] && this.cita()) {
      this.facade.setCita(this.cita());
      this.facade.cargarFormulario();
      // Reset contacto adicional PPR (legacy: trMailAdd oculto por defecto)
      this.facade.mostrarContactoAdicionalPPR = false;
      this.facade.form.dsnombreContactoPPR = '';
      this.facade.form.dscorreoContactoPPR = '';
      // Mostrar diálogo de periodicidad si aplica (legacy: setPeriodicityData())
      this.facade.mostrarDialogoPeriodicidadSiAplica();
    }

    // Pre-cargar datos de orden de servicio cuando se abre desde "Programar Servicio"
    // Legacy: SchedulingServicesCalendarActivity.java - setNmconsec_orden_serv_detalle()
    if (
      changes['ordenServicioDetalle'] &&
      this.ordenServicioDetalle() &&
      this.mode() === 'create'
    ) {
      this.precargarDatosOrden();
    }
  }

  /**
   * Pre-carga los datos del formulario desde la orden de servicio.
   * Se usa cuando se crea una cita desde "Programar Servicio" de órdenes.
   * Los campos de beneficiario y tarea se llenan automáticamente y no son editables.
   */
  private precargarDatosOrden(): void {
    const orden = this.ordenServicioDetalle();
    if (!orden) return;

    // Pre-cargar el beneficiario
    this.form.nmconsecutivoBeneficiario =
      orden.nmconsecutivoBeneficiario ?? null;
    this.form.dsnombreBeneficiario = orden.nombreBeneficiario || '';
    this.form.dsidentificacionBeneficiario = orden.dniBeneficiario || '';

    // Pre-cargar el centro de trabajo si existe
    if (orden.nmconsecCentroTrabajo) {
      this.form.nmconsecutivoCentroTrabajo = orden.nmconsecCentroTrabajo;
      this.form.dsnombreCentroTrabajo = orden.centroTrabajo || '';
    }

    // Pre-cargar la tarea
    this.form.nmconsecutivoTarea = orden.nmconsecutivo; // El consecutivo de la orden detalle ES la tarea
    this.form.dsnombreTarea = orden.tareaCliente || '';

    // Guardar el nmconsecOrdenServDetalle para el request de guardado
    this.form.nmconsecOrdenServDetalle = orden.nmconsecutivo;
  }

  // === Métodos privados ===

  // === Handlers (delegan al facade) ===
  onTipoCitaChange(): void {
    this.facade.onTipoCitaChange();
    // Legacy setScheduledQuantity(): al cambiar el tipo de cita se recalcula
    // la cantidad programada a partir de la duración ya ingresada.
    this.onDuracionChange(this.form.duracion ?? null);
  }

  /**
   * Maneja cambio en Atención Virtual (S/N).
   * Legacy: mostrarOcultarTransporte() en CrearCitaAdministrativaViewImpl.java
   */
  onVirtualChange(value: 'S' | 'N'): void {
    this.facade.onVirtualChange(value);
  }

  /** Cambio de Enlace Teams: reaplica la regla de visibilidad de Contactos. */
  onEnlaceTeamsChange(value: string): void {
    this.facade.onEnlaceTeamsChange(value);
  }

  /**
   * Guardar la cita.
   * Migrado: CrearCitaAdministrativaViewImpl.validateFields() / ServiceAppointmentInterfaceImpl.validateFields()
   *
    * Si es cita tardía (supera LIMIT_DAYS_PROGRAM días hábiles), muestra el diálogo
    * de justificación tanto al crear como al editar.
   */
  async guardar(): Promise<void> {
    if (!this.facade.validarCampos()) {
      return;
    }

    // Validar si es cita tardía (solo para CAMPO e INFORME desde Orden de Servicio)
    if (this.requiereValidacionTardia()) {
      // Sin la configuración real (festivos y límite) no se puede decidir si hay que pedir
      // justificación: se reintenta la carga y, si sigue fallando, no se guarda con valores por defecto.
      if (this.facade.loadingConfiguracion() || this.facade.configuracionError()) {
        await this.facade.cargarConfiguracion();
        if (this.facade.configuracionError()) {
          return;
        }
      }

      const fechaProgramacion = this.form.fechaCita;
      const config = this.configuracion();

      if (
        fechaProgramacion &&
        superaLimiteDiasHabiles(
          fechaProgramacion,
          new Date(),
          config.festivos,
          config.limiteDiasProgramacion
        )
      ) {
        // Mostrar diálogo de justificación
        this.dialogJustificacionVisible = true;
        return;
      }
    }

    this.ejecutarGuardado();
  }

  /**
   * Verifica si la cita requiere validación de cita tardía.
   * Aplica para CAMPO_COMPLEMENTARIO (42), INFORME_COMPLEMENTARIO (43) y PROGRAMACION_EN_CLIENTE (50).
   * También para CAMPO (17) e INFORME (18) desde Orden de Servicio.
   *
   * Legacy: CrearCitaAdministrativaViewImpl.citaAplicaJustificTardio()
   *         + ServiceAppointmentInterfaceImpl (para citas de servicio)
   */
  private requiereValidacionTardia(): boolean {
    const tipoCita = this.form.nmconsecutivoTipoCita;

    // Legacy CrearCitaAdministrativaViewImpl.citaAplicaJustificTardio():
    // CAMPO_COMPLEMENTARIO (42), INFORME_COMPLEMENTARIO (43), PROGRAMACION_EN_CLIENTE (50)
    if (
      tipoCita === TIPOS_CITA.CAMPO_COMPLEMENTARIO ||
      tipoCita === TIPOS_CITA.INFORME_COMPLEMENTARIO ||
      tipoCita === TIPOS_CITA.PROGRAMACION_EN_CLIENTE
    ) {
      return true;
    }

    // Para citas de servicio desde Orden de Servicio: CAMPO (17) e INFORME (18)
    if (this.esOrdenServicio()) {
      return tipoCita === TIPOS_CITA.CAMPO || tipoCita === TIPOS_CITA.INFORME;
    }

    return false;
  }

  /**
   * Handler cuando el usuario confirma la justificación tardía.
   */
  onJustificacionConfirmada(result: JustificacionTardiaResult): void {
    this.dialogJustificacionVisible = false;
    this.justificacionTardia = result;
    this.ejecutarGuardado();
  }

  /**
   * Handler cuando el usuario cancela la justificación tardía.
   */
  onJustificacionCancelada(): void {
    this.dialogJustificacionVisible = false;
    this.justificacionTardia = null;
  }

  /**
   * Ejecuta el guardado efectivo de la cita.
   * Usa el valor de snModifyPeriodicity que se estableció al cargar el formulario.
   * Si hay justificación tardía, la agrega al request.
   */
  private ejecutarGuardado(): void {
    // Construir request usando el facade, pasando la cita original
    const request = this.facade.buildSaveRequest(
      this.snModifyPeriodicity,
      this.cita()
    );

    // Agregar justificación tardía si existe
    if (this.justificacionTardia) {
      request.cdJustificacion = this.justificacionTardia.cdJustificacion;
      request.observacionesJustificacion =
        this.justificacionTardia.observaciones;
      // Limpiar para la próxima vez
      this.justificacionTardia = null;
    }

    this.onSave.emit(request);
  }

  confirmarCancelacion(): void {
    // Legacy: El diálogo de periodicidad ya se mostró al abrir la cita (mostrarDialogoPeriodicidadSiAplica)
    // Aquí solo usamos el valor snModifyPeriodicity que ya se estableció
    // ServiceAppointmentInterfaceImpl.java: getPresenter().cancelAppointment(list, getSnModifyPeriodicity())
    this.dialogCancelarVisible = true;
  }

  /**
   * Handler cuando el usuario confirma la cancelación desde el diálogo
   */
  onCancelacionConfirmada(result: CancelarCitaResult): void {
    this.dialogCancelarVisible = false;
    this.onCancel.emit(result);
    // NO cerrar visible aquí - dejar que el padre lo haga después de procesar
    // this.visible = false;
  }

  cumplir(): void {
    const cita = this.cita();
    if (!cita?.nmconsecutivoProg) {
      return;
    }

    // Cerrar el modal de detalle antes de abrir el flujo de cumplimiento.
    this.detalleCerradoParaCumplimiento = true;
    this.suprimirOnHide = true;
    this.visible = false;

    // Determinar tipo de cita
    const esCampo = esTipoCitaCampo(cita);
    const esInforme = esTipoCitaInforme(cita);
    this.esTipoCampo.set(esCampo);
    this.esTipoInforme.set(esInforme);

    // Mapear cita -> ProgramacionPendiente (datos locales, sin HTTP adicional)
    const programacionPendiente = this.mapearCitaAProgramacionPendiente(cita);
    this.mostrarBotonDescargarActa.set(false);
    this.nmconsecutivoCumplimientoDescargable = null;
    this.programacionParaCumplimiento.set(programacionPendiente);

    // Obtener orden de servicio para fallback de municipios
    const ordenDetalle = this.ordenServicioDetalle();

    // Precargar municipios de transporte
    // Prioridad: 1) Datos de la cita, 2) Datos de la orden de servicio
    const cdmunicipioOrigen =
      cita.cdmunicipioOrigen || ordenDetalle?.cdmunicipioOrigen;
    const dsmunicipioOrigen =
      cita.dsmunicipioOrigen || ordenDetalle?.municipioOrigen;
    const cdsuraOrigen = cita.cdsuraOrigen || ordenDetalle?.cdsuraOrigen;

    if (cdmunicipioOrigen || dsmunicipioOrigen) {
      this.municipioOrigenInicialCumplimiento.set({
        cdmunicipio: cdmunicipioOrigen,
        cdsura: cdsuraOrigen,
        dsmunicipio: dsmunicipioOrigen
      });
    } else {
      this.municipioOrigenInicialCumplimiento.set(null);
    }

    const cdmunicipioEntrega =
      cita.cdmunicipioEntrega || ordenDetalle?.cdmunicipioEntrega;
    const dsmunicipioEntrega =
      cita.dsmunicipioEntrega || ordenDetalle?.municipioDestino;
    const cdsuraEntrega = cita.cdsuraEntrega || ordenDetalle?.cdsuraEntrega;

    if (cdmunicipioEntrega || dsmunicipioEntrega) {
      this.municipioEntregaInicialCumplimiento.set({
        cdmunicipio: cdmunicipioEntrega,
        cdsura: cdsuraEntrega,
        dsmunicipio: dsmunicipioEntrega
      });
    } else {
      this.municipioEntregaInicialCumplimiento.set(null);
    }

    // Consultar saldo actualizado
    if (cita.nmconsecOrdenServDetalle) {
      this.loadingCumplimiento.set(true);
      this.cumplimientoRepo
        .obtenerSaldoOrden(cita.nmconsecOrdenServDetalle)
        .then((saldoResponse) => {
          this.saldoCumplimiento.set(saldoResponse.saldoPorEjecutar || 0);
          this.loadingCumplimiento.set(false);
        })
        .catch((error) => {
          if (!environment.production) {
            console.error('[CitaDialog] Error consultando saldo:', error);
          }
          this.saldoCumplimiento.set(0);
          this.loadingCumplimiento.set(false);
        });
    }

    this.requiereJustificacion.set(false);
    void this.cargarJustificacionesCumplimientoTardio();

    // Abrir el dialog
    this.dialogCumplimientoVisible.set(true);
  }

  /**
   * Carga el catálogo de justificaciones para el modal de cumplimiento tardío.
   * Mismo catálogo (TPSC_JUSTIFICACIONES) consumido por CumplimientosProgramadosFacade
   * y por ProgramarServicioDialogComponent.
   */
  private async cargarJustificacionesCumplimientoTardio(): Promise<void> {
    try {
      const opciones = await this.catalogoRepository.getJustificacionesCancelacion();
      this.justificacionesCumplimiento.set(
        opciones.map((opcion) => ({
          label: opcion.descripcion,
          value: opcion.codigo
        }))
      );
    } catch (error) {
      if (!environment.production) {
        console.error(
          '[CitaDialog] Error cargando justificaciones de cumplimiento tardío:',
          error
        );
      }
      this.justificacionesCumplimiento.set([]);
    }
  }

  onDialogHide(): void {
    if (this.suprimirOnHide) {
      this.suprimirOnHide = false;
      return;
    }
    this.onClose.emit();
  }

  /**
   * Mapea una ProgramacionServicio (cita) a ProgramacionPendiente
   * (formato requerido por FormularioCumplimientoComponent).
   *
   * Los municipios de transporte se obtienen de:
   * 1) Cita (TPSC_PROGRAMAC_SERVICIOS) si existen
   * 2) Orden de servicio detalle (TPSC_ORDEN_SERVICIO_DETAL) como fallback
   */
  private mapearCitaAProgramacionPendiente(
    cita: ProgramacionServicio
  ): ProgramacionPendiente {
    const ordenDetalle = this.ordenServicioDetalle();

    return {
      nmconsecutivo: cita.nmconsecutivoProg || 0,
      nmconsecOrdenServDetalle:
        cita.nmconsecOrdenServDetalle || ordenDetalle?.nmconsecutivo || 0,
      nmconsecutivoManualOrden:
        ordenDetalle?.codigoOrden ||
        cita.orientacionServicio ||
        cita.nmcodigoOrdenServicio ||
        '',
      nmconsecutivoTipoCita: cita.nmconsecutivoTipoCita,
      dstipoCita: cita.dstipoCita,
      dsnombreAseguradora: ordenDetalle?.aseguradora || cita.nombreAseguradora,
      dsnombreCliente:
        ordenDetalle?.nombreBeneficiario ||
        cita.nombreBeneficiario ||
        cita.dscliente,
      dsnombreBeneficiario:
        ordenDetalle?.nombreBeneficiario ||
        cita.nombreBeneficiario ||
        cita.dscliente,
      nmconsecutivoBeneficiario: ordenDetalle?.nmconsecutivoBeneficiario,
      dniBeneficiario: ordenDetalle?.dniBeneficiario || cita.dniBeneficiario,
      dsnombreContacto: cita.dsnombreContacto,
      dsemailContacto: cita.dsemailContacto,
      dscentroTrabajo: ordenDetalle?.centroTrabajo || cita.dscentroTrabajo,
      dstarea: ordenDetalle?.tareaCliente || cita.dstarea,
      dsnombreServicio: ordenDetalle?.servicioCgr || cita.dsservicioCGR,
      feprogramacion: cita.feprogramacion,
      horaInicial: cita.feprogramacion?.split('T')[1],
      nmhorasCita: cita.nmhorasCita,
      nmcantidadProgramada: cita.nmcantidadProgramada,
      saldoPorEjecutar: this.saldoCumplimiento(),
      cdestado: cita.cdestado,
      dsestado: cita.dsestado,
      // Campos de transporte (municipios origen/entrega) - fallback a orden de servicio
      cdmunicipioOrigen:
        cita.cdmunicipioOrigen || ordenDetalle?.cdmunicipioOrigen,
      dsmunicipioOrigen:
        cita.dsmunicipioOrigen || ordenDetalle?.municipioOrigen,
      cdsuraOrigen: cita.cdsuraOrigen || ordenDetalle?.cdsuraOrigen,
      cdmunicipioEntrega:
        cita.cdmunicipioEntrega || ordenDetalle?.cdmunicipioEntrega,
      dsmunicipioEntrega:
        cita.dsmunicipioEntrega || ordenDetalle?.municipioDestino,
      cdsuraEntrega: cita.cdsuraEntrega || ordenDetalle?.cdsuraEntrega,
      // Oficina/cliente de la orden: sin ellos el backend no puede aplicar el
      // respaldo de TPSC_VAL_TTE_PERIMETRO y el valor de transporte quedaba en 0.
      // Legacy: getOficinaOrden()/getCliente() → AdminValorTransporteHandler
      nmconsecutivoOficina:
        cita.nmconsecutivoOficina ?? ordenDetalle?.nmconsecutivoOficina,
      nmconsecutivoCliente:
        cita.nmconsecutivoCliente ?? ordenDetalle?.nmconsecutivoCliente,
      // Citas complementarias (sin orden): el backend resuelve oficina y cliente
      // desde el asesor. Legacy: CrearCitaAdministrativaActivity.fulFillment().
      nmconsecutivoAsesor: cita.nmconsecutivoAsesor,
      // Campos de población y valor transporte
      cdpoblacion: cita.cdpoblacion,
      dspoblacion: cita.dspoblacion,
      ptvalorTransporte: cita.ptvalorTransporte,
      snpagoTransporteEmpleado: cita.snpagoTransporteEmpleado,
      // Campos de acta (HU1132419): necesarios para visibilidad y render en cumplimiento
      dsclasificacion:
        cita.dsclasificacion || ordenDetalle?.clasificacion || '',
      cdcontratoBeneficiario: cita.dscontratoBeneficiario || ''
    };
  }

  onDialogCumplimientoVisibleChange(visible: boolean): void {
    if (!visible) {
      this.cerrarDialogCumplimiento();
    }
  }

  onCancelarCumplimientoDesdeAgenda(): void {
    // El contenedor de agenda recarga y luego invoca finalizarRegresoCumplimiento().
    this.onRegresarDesdeCumplimiento.emit();
  }

  finalizarRegresoCumplimiento(): void {
    this.cerrarDialogCumplimiento();
    this.detalleCerradoParaCumplimiento = false;
    this.visible = false;
    this.onClose.emit();
  }

  /**
   * Abre la gestión de contactos del informe Final y espera a que cargue.
   *
   * @param cerrarCitaAlCerrar si es true, la cita se cierra cuando el usuario cierra el modal de contactos
   * @returns true si se abrió el modal (la cita queda abierta hasta que se cierre)
   */
  private async abrirContactosInformeSiPendiente(
    pendiente: GestionContactosInformePendiente | null,
    cerrarCitaAlCerrar: boolean
  ): Promise<boolean> {
    if (!pendiente || !this.contactosInformeDialog) {
      return false;
    }
    this.cerrarCitaAlCerrarContactos = cerrarCitaAlCerrar;
    await this.contactosInformeDialog.abrir(pendiente.radicado, pendiente.cumplimientos);
    return true;
  }

  /** El modal de contactos del informe se cerró: si la cita lo esperaba, ahora se cierra y se notifica al padre. */
  onContactosInformeCerrado(): void {
    if (!this.cerrarCitaAlCerrarContactos) {
      return;
    }
    this.cerrarCitaAlCerrarContactos = false;
    this.finalizarRegresoCumplimiento();
  }

  async onGuardarCumplimiento(request: CumplimientoRequest): Promise<void> {
    this.loadingCumplimiento.set(true);

    try {
      const response =
        await this.cumplimientoRepo.registrarCumplimiento(request);
      avisarPostPersistencia(this.messageService, response);
      const contactosInformePendiente = gestionContactosInformeSiAplica(request, response);

      if (response?.nmconsecutivo) {
        const citaId = this.cita()?.nmconsecutivoProg;

        this.messageService.add({
          severity: 'success',
          summary: 'Cumplimiento Registrado',
          detail: 'El cumplimiento se ha registrado correctamente'
        });
        if (response.idActa360) {
          this.nmconsecutivoCumplimientoDescargable = response.nmconsecutivo;
          this.mostrarBotonDescargarActa.set(true);
          this.messageService.add({
            severity: 'success',
            summary: 'Acta asociada',
            detail: `El acta ${response.idActa360} fue generada y asociada al cumplimiento.`
          });

          if (citaId) {
            this.onCumplimientoRegistrado.emit(citaId);
          }
          await this.abrirContactosInformeSiPendiente(contactosInformePendiente, false);
          return;
        }

        // IMPORTANTE: Emitir evento ANTES de cerrar para que el padre pueda refrescar

        if (citaId) {
          this.onCumplimientoRegistrado.emit(citaId);
        }

        this.cerrarDialogCumplimiento();
        // Legacy (gestionarContactosInforme): el modal de contactos se muestra tras guardar un informe
        // Final. La cita no puede cerrarse antes: el padre destruye este componente y con él el modal.
        if (await this.abrirContactosInformeSiPendiente(contactosInformePendiente, true)) {
          return;
        }
        // Cerrar el dialog principal y notificar al padre
        this.visible = false;
        this.onClose.emit();
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo registrar el cumplimiento'
        });
      }
    } catch (error: any) {
      console.error('[CitaDialog] Error guardando cumplimiento:', error);
      const detalle =
        error?.error?.message ??
        error?.error?.detail ??
        error?.message ??
        'Ocurrió un error al registrar el cumplimiento';
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: detalle,
        life: 8000
      });
    } finally {
      this.loadingCumplimiento.set(false);
    }
  }

  onFechaCumplimientoChange(fecha: Date): void {
    if (!environment.production) {
      console.log('[CitaDialog] Fecha cumplimiento cambió:', fecha);
    }
  }

  async reportarAlertaTemprana(): Promise<void> {
    await abrirAlertaTemprana(
      this.programacionParaCumplimiento(),
      this.messageService
    );
  }

  async onVerHistorialCumplimientos(): Promise<void> {
    const prog = this.programacionParaCumplimiento();
    if (!prog?.nmconsecutivo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin programación',
        detail: 'No hay programación seleccionada'
      });
      return;
    }

    try {
      this.loadingHistorial.set(true);
      const cumplimientos =
        await this.cumplimientoRepo.listarHistorialCumplimientos(
          prog.nmconsecutivo
        );
      this.historialCumplimientos.set(cumplimientos);
      this.historialCumplimientosVisible.set(true);
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo cargar el historial de cumplimientos'
      });
    } finally {
      this.loadingHistorial.set(false);
    }
  }

  cerrarDialogCumplimiento(): void {
    this.dialogCumplimientoVisible.set(false);
    this.programacionParaCumplimiento.set(null);
    this.saldoCumplimiento.set(0);
    this.esTipoCampo.set(false);
    this.esTipoInforme.set(false);
    this.requiereJustificacion.set(false);
    this.justificacionesCumplimiento.set([]);
    // Limpiar municipios precargados
    this.municipioOrigenInicialCumplimiento.set(null);
    this.municipioEntregaInicialCumplimiento.set(null);
    this.mostrarBotonDescargarActa.set(false);
    this.descargandoActaAsociada.set(false);
    this.nmconsecutivoCumplimientoDescargable = null;
  }

  async onDescargarActaAsociada(): Promise<void> {
    const nmconsecutivo = this.nmconsecutivoCumplimientoDescargable;
    if (!nmconsecutivo) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Sin documento',
        detail: 'No hay un acta asociada disponible para descargar'
      });
      return;
    }

    this.descargandoActaAsociada.set(true);
    try {
      await this.cumplimientoRepo.descargarActaPdf(
        nmconsecutivo,
        `acta_${nmconsecutivo}.pdf`
      );
      this.messageService.add({
        severity: 'success',
        summary: 'Descarga iniciada',
        detail: 'El documento se está descargando'
      });
    } catch (error) {
      const mensaje =
        error instanceof Error
          ? error.message
          : 'Error al descargar el documento';
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: mensaje
      });
    } finally {
      this.descargandoActaAsociada.set(false);
    }
  }

  // === Helpers de formato (delegan al facade) ===
  formatFecha(fecha?: string): string {
    return this.facade.formatFecha(fecha);
  }

  getPeriodicidadLabel(codigo?: string): string {
    return this.facade.getPeriodicidadLabel(codigo);
  }

  formatHora(fecha?: string): string {
    return this.facade.formatHora(fecha);
  }

  formatDuracion(horas?: number): string {
    return this.facade.formatDuracion(horas);
  }

  formatDecimal(value?: number): string {
    return this.facade.formatDecimal(value);
  }

  /**
   * Abre el diálogo de búsqueda de contactos del centro de trabajo.
   * Legacy: AdminContactosHandler.listarContactosBenefOrden()
   */
  async abrirBusquedaContacto(): Promise<void> {
    const cita = this.cita();
    const ordenDetalle = this.ordenServicioDetalle();
    const tipoCita = this.facade.tiposCita.find(
      (t) => t.nmconsecutivo === this.form.nmconsecutivoTipoCita
    );

    // Legacy (CrearCitaAdministrativaViewImpl.onLookUpClick):
    // 1. Línea AT (dsuso_cita = 'LINEAAT'): contactos del cliente seleccionado; sin cliente → alerta.
    // 2. Sincronización Outlook (Teams) = Sí y tipo distinto de CAMPO: contactos de la persona del asesor.
    // 3. En otro caso: contactos de la orden (centro de trabajo o, si no tiene, beneficiario).
    //    Si no hay orden ni beneficiario (cita administrativa), se usa la persona del asesor para que
    //    el listado y el alta funcionen igual con Enlace Teams Sí o No.
    let origen: { nmconsecCt?: number | null; cdpersona?: number | null };
    if (tipoCita?.dsusoCita === USO_CITA_LINEA_AT) {
      const cdpersonaCliente =
        this.cdpersonaClienteSeleccionado ?? cita?.cdpersonaBeneficiario ?? null;
      if (!this.form.nmconsecutivoBeneficiario || !cdpersonaCliente) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Contacto',
          detail: 'Por favor seleccione primero el cliente'
        });
        return;
      }
      origen = { cdpersona: cdpersonaCliente };
    } else if (
      this.form.snEnlaceTeams === 'S' &&
      this.form.nmconsecutivoTipoCita !== TIPOS_CITA_IDS.CAMPO
    ) {
      origen = { cdpersona: await this.facade.resolverPersonaAsesor(cita?.cdpersonaAsesor) };
    } else {
      // El beneficiario/centro de trabajo guardados en la cita solo cuentan si la cita viene de una orden
      // (o es CAMPO, como antes). Una cita administrativa los puede traer al editar y no al crear:
      // sin esta condición, crear y editar listarían contactos de personas distintas.
      const usaOrden =
        !!ordenDetalle ||
        !!cita?.nmconsecOrdenServDetalle ||
        this.form.nmconsecutivoTipoCita === TIPOS_CITA_IDS.CAMPO;
      const nmconsecCt = usaOrden
        ? cita?.nmconsecBenefCt || ordenDetalle?.nmconsecCentroTrabajo || null
        : null;
      const cdpersonaOrden = usaOrden
        ? ordenDetalle?.cdpersBeneficiario ?? cita?.cdpersonaBeneficiario ?? null
        : null;
      origen =
        nmconsecCt || cdpersonaOrden
          ? { nmconsecCt, cdpersona: cdpersonaOrden }
          : { cdpersona: await this.facade.resolverPersonaAsesor(cita?.cdpersonaAsesor) };
    }

    // La paginación es de servidor: solo se trae la primera página.
    await this.facade.abrirContactos(origen);
    this.dialogContactosVisible = true;
  }

  /** Navegación de páginas del diálogo de contactos (consulta real al backend). */
  async onPaginarContactos(accion: AccionPaginacionContactos): Promise<void> {
    await this.facade.paginarContactos(accion);
  }

  /**
   * Maneja la selección de un contacto desde el diálogo.
   */
  onContactoSeleccionado(contacto: ContactoCentroTrabajo): void {
    // Modificar directamente el form (mismo patrón que cliente/tarea/centro de trabajo)
    this.form.nmconsecutivoContacto = contacto.nmconsecutivo ?? null;
    this.form.dsnombreContacto = contacto.dsnombre;
    this.form.dstelefonoContacto = contacto.dstelefonoFijo || '';
    this.form.dscelularContacto = contacto.dstelefonoCelular || '';
    this.form.dsemailContacto = contacto.dsemail || '';
    this.dialogContactosVisible = false;
  }

  /**
   * Maneja la creación de un nuevo contacto.
   * Para citas de servicio, usa el cdpersona del beneficiario y el centro de trabajo de la orden.
   */
  async onContactoCreado(contacto: ContactoCentroTrabajo): Promise<void> {
    // Legacy: se crea con la persona y el centro de trabajo del mismo origen del listado,
    // así el contacto queda vinculado y aparece en la lista
    const origen = this.facade.origenContactosActual;
    const cdpersona = origen.cdpersona ?? undefined;
    const nmconsecCt = origen.nmconsecCt ?? undefined;

    const success = await this.facade.crearContacto(
      contacto,
      cdpersona,
      nmconsecCt
    );
    // La lista ya se refrescó en la página actual (facade.recargarContactos); si falló,
    // se devuelve el formulario con lo digitado para no perderlo
    if (!success) {
      this.errorGuardadoContactos++;
    }
  }

  /**
   * Maneja la modificación de un contacto existente.
   * Para citas de servicio, usa el cdpersona del beneficiario.
   */
  async onContactoModificado(contacto: ContactoCentroTrabajo): Promise<void> {
    const cdpersona = this.facade.origenContactosActual.cdpersona ?? undefined;

    const success = await this.facade.modificarContacto(contacto, cdpersona);
    if (!success) {
      this.errorGuardadoContactos++;
    }
  }

  /**
   * Calcula la fecha final (delega al facade).
   */
  calcularFechaFinal(): void {
    this.facade.calcularFechaFinal();
  }

  /**
   * Calcula las repeticiones (delega al facade).
   */
  calcularRepeticiones(): void {
    this.facade.calcularRepeticiones();
  }

  /**
   * Evento cuando cambia la periodicidad.
   */
  onPeriodicidadChange(): void {
    this.facade.onPeriodicidadChange();
  }

  /**
   * Evento cuando cambian las repeticiones.
   */
  onRepeticionesChange(): void {
    this.facade.onRepeticionesChange();
  }

  /**
   * Evento cuando cambia la fecha final.
   */
  onFechaFinalChange(): void {
    this.facade.onFechaFinalChange();
  }

  // ============================================================================
  // BUSQUEDAS DINAMICAS
  // Legacy: CrearCitaAdministrativaViewImpl - onClientSearch, onCenterJobSearch, onTaskSearch
  // ============================================================================

  /**
   * Abre búsqueda de cliente/beneficiario.
   * Legacy: BuscadorBeneficiariosActivity - busca en TPSC_BENEFICIARIO
   */
  abrirBusquedaCliente(): void {
    this.dialogBuscarClienteVisible = true;
  }

  /**
   * Maneja selección de cliente.
   * Actualiza los campos: contrato, identificación, nombre comercial
   */
  onClienteSeleccionado(cliente: ClienteSeleccionado): void {
    // Modificar directamente el form (mismo patrón que el backup)
    this.form.nmconsecutivoBeneficiario = cliente.nmconsecutivo;
    // Legacy (Línea AT): los contactos se listan y crean con la persona del cliente seleccionado
    this.cdpersonaClienteSeleccionado = cliente.cdpersona ?? null;
    this.form.dscontratoBeneficiario = cliente.contrato || '';
    this.form.dsidentificacionBeneficiario = cliente.numeroIdentificacion;
    this.form.dsnombreBeneficiario = cliente.nombreComercial;
    // Limpiar centro de trabajo al cambiar cliente
    this.form.nmconsecutivoCentroTrabajo = null;
    this.form.dsnombreCentroTrabajo = '';
    this.dialogBuscarClienteVisible = false;
  }

  /**
   * Abre búsqueda de centro de trabajo.
   */
  abrirBusquedaCentroTrabajo(): void {
    if (!this.form.nmconsecutivoBeneficiario) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Seleccione cliente',
        detail: 'Primero debe seleccionar un cliente',
        life: 3000
      });
      return;
    }
    this.dialogBuscarCentroTrabajoVisible = true;
  }

  /**
   * Abre búsqueda de PPR (Profesional).
   */
  abrirBusquedaPPR(): void {
    this.dialogBuscarProfesionalVisible = true;
  }

  /**
   * Procesa la selección de un profesional.
   * Legacy: stbNamePpr.setText(), stbMailPpr.setText()
   */
  onProfesionalSeleccionado(profesional: Profesional): void {
    this.form.nmconsecutivoPPR = profesional.nmconsecutivo;
    this.form.dsnombrePPR = profesional.dsnombre;
    this.form.dscorreoPPR = profesional.dsmail || '';
    this.dialogBuscarProfesionalVisible = false;
    this.messageService.add({
      severity: 'success',
      summary: 'Profesional seleccionado',
      detail: `${profesional.dni} - ${profesional.dsnombre}`,
      life: 3000
    });
  }

  /**
   * Muestra la fila de contacto adicional para PPR.
   */
  agregarContactoPPR(): void {
    this.mostrarContactoAdicionalPPR = true;
  }

  /**
   * Oculta y limpia la fila de contacto adicional para PPR.
   */
  eliminarContactoPPR(): void {
    this.mostrarContactoAdicionalPPR = false;
    this.form.dsnombreContactoPPR = '';
    this.form.dscorreoContactoPPR = '';
  }

  /**
   * Maneja cambio de datos del panel de transporte.
   */
  onTransporteDataChange(data: TransporteData): void {
    this.facade.onTransporteDataChange(data);
  }

  /**
   * Abre búsqueda de Unidad de Negocio.
   */
  abrirBusquedaUnidadNegocio(): void {
    this.dialogBuscarUnidadNegocioVisible = true;
  }

  /**
   * Maneja selección de unidad de negocio.
   * Legacy: tbUnidadNegocio.setValue(nmconsecutivo + " - " + dsnovedad)
   */
  onUnidadNegocioSeleccionada(unidad: UnidadNegocio): void {
    this.form.nmconsecutivoUnidadNegocio = unidad.nmconsecutivo;
    this.form.dsunidadNegocio =
      unidad.displayFormat || `${unidad.nmconsecutivo} - ${unidad.dsunidad}`;
    this.dialogBuscarUnidadNegocioVisible = false;
  }

  /**
   * Maneja selección de centro de trabajo.
   * Muestra formato: "NOMBRE - CONSECUTIVO - NOMBRE_COMERCIAL"
   */
  onCentroTrabajoSeleccionado(centro: CentroTrabajoSeleccionado): void {
    this.form.nmconsecutivoCentroTrabajo = centro.nmconsecutivo;
    this.form.dsnombreCentroTrabajo = centro.descripcionCompleta;
    this.dialogBuscarCentroTrabajoVisible = false;
  }

  /**
   * Abre búsqueda de tarea.
   */
  abrirBusquedaTarea(): void {
    this.dialogBuscarTareaVisible = true;
  }

  /**
   * Maneja selección de tarea.
   * Muestra formato: "CODIGO - NOMBRE_TAREA"
   */
  onTareaSeleccionada(tarea: TareaSeleccionada): void {
    this.form.nmconsecutivoTarea = tarea.nmconsecutivo;
    this.form.dsnombreTarea = tarea.descripcionCompleta;
    this.dialogBuscarTareaVisible = false;
  }

  /**
   * Abre búsqueda de beneficiario.
   */
  abrirBusquedaBeneficiario(): void {
    this.dialogBuscarClienteVisible = true;
  }

  /**
   * Abre el formateador de dirección.
   */
  async abrirBusquedaDireccion(): Promise<void> {
    // Cargar nomenclaturas si no están cargadas
    if (this.tiposVia().length === 0) {
      await this.cargarNomenclaturasDireccion();
    }

    // Abrir el formateador con la dirección actual si existe
    this.formateadorDireccion?.abrir(this.form.dsdireccion || '');
  }

  /**
   * Carga las nomenclaturas necesarias para el formateador de dirección.
   * Legacy: UtilidadesBuscadores.llenarListBox() con datos de TPSC_PARAM_NOMENCLATURA
   */
  private async cargarNomenclaturasDireccion(): Promise<void> {
    try {
      const [tiposVia, apendices, cardinalidades] = await Promise.all([
        this.nomenclaturaRepository.listarTiposVia(),
        this.nomenclaturaRepository.listarApendices(),
        this.nomenclaturaRepository.listarCardinalidades()
      ]);

      // Mapear a NomenclaturaDto para compatibilidad con FormateadorDireccionComponent
      this.tiposVia.set(
        tiposVia.map((t) => ({ codigo: t.codigo, descripcion: t.descripcion }))
      );
      this.apendices.set(
        apendices.map((a) => ({ codigo: a.codigo, descripcion: a.descripcion }))
      );
      this.cardinalidades.set(
        cardinalidades.map((c) => ({
          codigo: c.codigo,
          descripcion: c.descripcion
        }))
      );
    } catch (error) {
      if (!environment.production) {
        console.error('Error cargando nomenclaturas de dirección:', error);
      }
      // El formateador puede funcionar con arrays vacíos permitiendo entrada manual
    }
  }

  /**
   * Recibe la dirección formateada del componente FormateadorDireccion.
   * Legacy: IngresarDireccionFormateadaActivity.PresenterDir.postOpenDialog(direccion)
   */
  onDireccionFormateada(evento: {
    direccion: string;
    municipio?: Municipio;
    barrio?: string;
  }): void {
    // Actualizar el campo de dirección con la dirección formateada
    this.form.dsdireccion = evento.direccion;

    // Si se seleccionó un municipio, podríamos usarlo para otros campos si es necesario
    // Por ahora el legacy solo usa la dirección formateada
  }

  /**
   * Actualiza la cantidad programada cuando cambia la duración.
   * La cantidad programada es igual a la duración en horas.
   */
  onDuracionChange(duracion: Date | null): void {
    if (duracion && this.visibility().mostrarCantidadProgramada) {
      const horasTotales =
        duracion.getHours() + duracion.getMinutes() / 60;
      this.form.nmcantidadProgramada = redondearCantidad(horasTotales);
    }
  }
}
